<template>
  <!-- Filter Responsive Start -->
  <div class="filter_responsive">
    <div class="filter_cta_wrapper">
      <button id="filterCta" class="filter_cta" aria-label="Filter" @click="myFilter">
        {{ decodedShopifyData.filterDropdownTextResponsive }}
      </button>
      <button id="sortCta" class="filter_cta" aria-label="Sort" @click="sortBy">
        {{ decodedShopifyData.sortByDropdownTextResponsive }}
      </button>
    </div>
  </div>
  <!-- Filter Responsive End -->
  <!-- Debug Toggle Start -->
  <div
    v-if="shouldShowDebug"
    style="position: fixed; bottom: 12px; right: 12px; z-index: 9999; font-size: 12px"
  >
    <button
      style="background: #111; color: #fff; padding: 6px 8px; border-radius: 6px; border: 0"
      aria-label="Show Products Debug"
      @click="debugOpen = !debugOpen"
    >
      {{ debugOpen ? 'Hide' : 'Show' }} Products Debug
    </button>
    <div
      v-if="debugOpen"
      style="
        max-width: 680px;
        max-height: 60vh;
        overflow: auto;
        background: #fff;
        color: #000;
        border: 1px solid #ddd;
        padding: 10px;
        margin-top: 6px;
      "
    >
      <div style="font-weight: 700; margin-bottom: 6px">Products Debug</div>
      <div style="margin-bottom: 6px">
        <strong>Parsed total:</strong> {{ ProductsRaw?.length || 0 }}
      </div>
      <div style="margin-bottom: 6px">
        <strong>Processed (rendered) products:</strong> {{ Products.length }}
      </div>
      <div v-if="diagnostics && diagnostics.length" style="margin-top: 8px">
        <div style="font-weight: 700; margin-bottom: 6px">
          Per-product diagnostics (showing first 200)
        </div>
        <div
          v-for="(d, idx) in diagnostics.slice(0, 200)"
          :key="idx"
          style="padding: 6px; border-top: 1px solid #f1f1f1"
        >
          <div>
            <strong>#{{ d.index }}</strong> — <em>{{ d.handle || d.title || 'unknown' }}</em>
          </div>
          <div style="color: #b00">
            Excluded: {{ d.included ? 'no' : 'yes' }}
            {{ !d.included && d.reasons ? '(' + d.reasons.join(', ') + ')' : '' }}
          </div>
          <div style="font-size: 11px; color: #333; white-space: pre-wrap">
            {{ d.note }}
          </div>
        </div>
      </div>
      <div style="margin-top: 8px; font-weight: 700">Raw listing preview</div>
      <pre
        style="
          white-space: pre-wrap;
          max-height: 200px;
          overflow: auto;
          background: #fafafa;
          padding: 8px;
        "
        >{{ ProductsRawPreview }}</pre
      >
    </div>
  </div>
  <!-- Debug Toggle End -->

  <!-- Collection Banner Code Start -->
  <!-- Collection Banner Code -->

  <!-- it is commented for hide the banner image with heading in all collection pages -->
  <!--
  <div class="collaction_banner tmb-collection-banner">
    <div>
      <img
        v-if="decodedShopifyData.bannerImage.length > 0 "
        v-lazy="decodedShopifyData.bannerImage"
        loading="lazy"
        aria-hidden="true"
        aria-label="Collection Banner Image"
        width="100%"
        height="auto"
      >
      <h2
        v-if="decodedShopifyData.bannerHeading.length > 0 "
        class="banner_heading"
        :class="decodedShopifyData.bannerImage ? '' : 'heading-without-banner'"
      >
        {{ decodedShopifyData.bannerHeading }}
      </h2>
    </div>
  </div> -->

  <!-- Collection Banner Code End -->
  <!-- New Collection Banner with Text Only -->
  <div
    v-if="decodedShopifyData.renderHero === 'true' || decodedShopifyData.renderHero === true"
    class="collection_banner_section"
  >
    <div class="collection_banner_content">
      <h1
        v-if="bannerHeadingDecoded && bannerHeadingDecoded.length > 0"
        class="collection_banner_heading"
      >
        {{ bannerHeadingDecoded }}
      </h1>
    </div>
  </div>
  <!-- New Collection Banner with Text Only End -->

  <!-- Filter Row Start -->
  <div class="filter_row">
    <div class="row_inner">
      <div class="apply_filter_cta_wrapper">
        <button class="apply_filter_cta" disabled aria-label="Apply Filter" @click="applyfilter">
          {{ decodedShopifyData.applyFilterCta }}
        </button>
      </div>
      <div class="filters">
        <div class="filters_inner_row">
          <div class="filters_responsive">
            <div class="close-btn" aria-label="Close Menu" @click="closeMenu">
              <svg
                width="48"
                height="48"
                viewBox="0 0 48 48"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M11.8861 11.8864L35.6587 35.6589" stroke="#656565" stroke-width="1.5" />
                <path d="M11.8861 35.6586L35.6587 11.886" stroke="#656565" stroke-width="1.5" />
              </svg>
            </div>
            <div class="filter_cta_wrapper">
              <button class="filter_cta filter-modifier" aria-label="Filter">
                {{ decodedShopifyData.filterinnerResponsive }}
              </button>
              <button
                class="filter_cta clear-modifier"
                aria-label="Clear Filters"
                :class="{ activeClear: showClearAll }"
                disabled
                @click="clearAllFilter()"
              >
                CLEAR FILTERS
                <svg
                  width="6"
                  height="6"
                  viewBox="0 0 6 6"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  data-v-bb57343a=""
                >
                  <path d="M0.5 1L5 5.5L2.75 3.25L0.5 1Z" stroke="white" data-v-bb57343a="" />
                  <path d="M5 1L0.5 5.5L2.75 3.25L5 1Z" stroke="white" data-v-bb57343a="" />
                </svg>
              </button>
            </div>
          </div>
          <div class="filters_inner" :style="[hideAllCategorydropdown ? { display: 'none' } : {}]">
            <!-- Categories filter -->

            <div
              v-if="hideCategorydropdown === 1"
              class="filter"
              :style="[ddTestCategory[0].length === 0 ? { display: 'none' } : {}]"
              @mouseenter="isMobile == true ? null : (show = true)"
              @mouseleave="isMobile == true ? null : (show = false)"
              @click="isMobile == false ? null : closeDropDown(show, 'show')"
            >
              <!-- v-on:mouseover="show = !show" -->
              <div
                class="dropdown"
                @click="
                  (event) => {
                    addActive(event);
                  }
                "
              >
                <div class="overselect">
                  <svg
                    width="10"
                    height="6"
                    viewBox="0 0 10 6"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 1L5 5L9 1"
                      stroke="black"
                      stroke-width="0.75"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <button class="c-form-input" aria-label="Categories">Categories</button>
              </div>
              <div class="multiselect" :class="{ active: show }">
                <div class="tmb_header_dopdown">
                  <ul>
                    <li v-for="option in ddTestCategory[0]" :key="'Categories_' + option.id">
                      <input
                        :id="'Categories_' + option.id"
                        class="multiselectOption"
                        type="checkbox"
                        name="category"
                        :value="option.value"
                        @change="onCheck($event)"
                      />
                      <label class="optionLabel" :for="'Categories_' + option.id"
                        >{{ option.text.toLowerCase() }}
                      </label>
                    </li>
                  </ul>
                  <div class="btn_wrapper">
                    <!-- <button class="filterBtn modifier" @click="filterProduct">Apply</button> -->
                    <button
                      class="filterBtn"
                      aria-label="Clear Categories"
                      @click="clearCheckBoxs('category')"
                    >
                      Clear
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <!-- color filter -->
            <div
              class="filter color-filter"
              :style="[ddTestColor[0].length === 0 ? { display: 'none' } : {}]"
              @mouseenter="isMobile == true ? null : (showColor = true)"
              @mouseleave="isMobile == true ? null : (showColor = false)"
              @click="isMobile == false ? null : closeDropDown(showColor, 'showColor')"
            >
              <div
                class="dropdown"
                @click="
                  (event) => {
                    addActive(event);
                  }
                "
              >
                <div class="overselect">
                  <svg
                    width="10"
                    height="6"
                    viewBox="0 0 10 6"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 1L5 5L9 1"
                      stroke="black"
                      stroke-width="0.75"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <button class="c-form-input" aria-label="Color">Color</button>
              </div>
              <div class="multiselect" :class="{ active: showColor }">
                <div class="tmb_header_dopdown">
                  <ul>
                    <li v-for="option in ddTestColor[0]" :key="'Color_' + option.id">
                      <input
                        :id="'Color_' + option.id"
                        class="multiselectOption"
                        type="checkbox"
                        name="color"
                        :value="option.value"
                        @change="onCheckColor($event)"
                      />
                      <label class="optionLabel" :for="'Color_' + option.id">{{
                        option.text.toLowerCase()
                      }}</label>
                    </li>
                  </ul>
                  <div class="btn_wrapper">
                    <!-- <button class="filterBtn modifier" @click="filterProductByColor">Apply</button> -->
                    <button
                      class="filterBtn"
                      aria-label="Clear Colors"
                      @click="clearCheckBoxs('color')"
                    >
                      Clear
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <!-- size filter -->
            <div
              class="filter size-filter"
              :style="[ddTestSize.length === 0 ? { display: 'none' } : {}]"
              @mouseenter="isMobile == true ? null : (showSize = true)"
              @mouseleave="isMobile == true ? null : (showSize = false)"
              @click="isMobile == false ? null : closeDropDown(showSize, 'showSize')"
            >
              <div
                class="dropdown"
                @click="
                  (event) => {
                    addActive(event);
                  }
                "
              >
                <div class="overselect">
                  <svg
                    width="10"
                    height="6"
                    viewBox="0 0 10 6"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 1L5 5L9 1"
                      stroke="black"
                      stroke-width="0.75"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <button class="c-form-input" aria-label="Size">Size</button>
              </div>
              <div class="multiselect" :class="{ active: showSize }">
                <div class="tmb_header_dopdown">
                  <ul>
                    <li v-for="option in ddTestSize" :key="'Size_' + option.id">
                      <input
                        :id="'Size_' + option.id"
                        class="multiselectOption"
                        type="checkbox"
                        name="size"
                        :value="option.value"
                        @change="onCheckSize($event)"
                      />
                      <label class="optionLabel" :for="'Size_' + option.id"
                        >{{ option.text.toLowerCase() }}
                      </label>
                    </li>
                  </ul>
                  <div class="btn_wrapper">
                    <!-- <button class="filterBtn modifier" @click="filterProductBySize">Apply</button> -->
                    <button
                      class="filterBtn"
                      aria-label="Clear Sizes"
                      @click="clearCheckBoxs('size')"
                    >
                      Clear
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <!-- material filter -->
            <div
              class="filter filter-modifier"
              :style="[ddTestMaterial[0].length === 0 ? { display: 'none' } : {}]"
              @mouseenter="isMobile == true ? null : (showMaterial = true)"
              @mouseleave="isMobile == true ? null : (showMaterial = false)"
              @click="isMobile == false ? null : closeDropDown(showMaterial, 'showMaterial')"
            >
              <div
                class="dropdown"
                @click="
                  (event) => {
                    addActive(event);
                  }
                "
              >
                <div class="overselect">
                  <svg
                    width="10"
                    height="6"
                    viewBox="0 0 10 6"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 1L5 5L9 1"
                      stroke="black"
                      stroke-width="0.75"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <button class="c-form-input" aria-label="Material">Material</button>
              </div>
              <div class="multiselect" :class="{ active: showMaterial }">
                <div class="tmb_header_dopdown">
                  <ul>
                    <li v-for="option in ddTestMaterial[0]" :key="'Material_' + option.id">
                      <input
                        :id="'Material_' + option.id"
                        class="multiselectOption"
                        type="checkbox"
                        name="material"
                        :value="option.value"
                        @change="onCheckMaterial($event)"
                      />
                      <label class="optionLabel" :for="'Material_' + option.id"
                        >{{ option.text.toLowerCase() }}
                      </label>
                    </li>
                  </ul>
                  <div class="btn_wrapper">
                    <!-- <button class="filterBtn modifier" @click="filterProductByMaterial">Apply</button> -->
                    <button
                      class="filterBtn"
                      aria-label="Clear Materials"
                      @click="clearCheckBoxs('material')"
                    >
                      Clear
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <!-- Clear Filter -->
            <div class="filter">
              <button
                class="clearFilter"
                aria-label="Clear Filters"
                :class="{ activeClear: showClearAll }"
                @click="clearAllFilter()"
              >
                Clear filters
                <svg
                  width="6"
                  height="6"
                  viewBox="0 0 6 6"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M0.5 1L5 5.5L2.75 3.25L0.5 1Z" stroke="white" />
                  <path d="M5 1L0.5 5.5L2.75 3.25L5 1Z" stroke="white" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="sort_by">
        <div class="filters_responsive">
          <div class="close-btn" aria-label="Close Menu" @click="closeMenu">
            <svg
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M11.8861 11.8864L35.6587 35.6589" stroke="#656565" stroke-width="1.5" />
              <path d="M11.8861 35.6586L35.6587 11.886" stroke="#656565" stroke-width="1.5" />
            </svg>
          </div>
          <div class="filter_cta_wrapper">
            <button class="filter_cta filter-modifier" aria-label="Sort By">
              {{ decodedShopifyData.sortinnerResponsive }}
            </button>
          </div>
        </div>
        <div class="sort_by_inner">
          <div class="range">
            <div class="add_remove">
              <button aria-label="Decrease" @click="sliderChangeManully('nagtive')">-</button>
              <button aria-label="Increase" @click="sliderChangeManully('postive')">+</button>
            </div>
            <input
              id="ageInputId"
              type="range"
              value="4"
              values="4"
              min="2"
              max="6"
              step="2"
              class="progress"
              @input="sliderChange($event)"
            />
          </div>
          <div class="sortFilter" @mouseenter="showSort = true" @mouseleave="showSort = false">
            <button class="sortBtn" aria-label="Sort By">
              Sort By
              <svg
                width="10"
                height="6"
                viewBox="0 0 10 6"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  data-v-35171425=""
                  d="M1 1L5 5L9 1"
                  stroke="black"
                  stroke-width="0.75"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
            <div class="multiselect" :class="{ active: showSort }">
              <div class="tmb_header_dopdown">
                <ul>
                  <li v-for="option in ddTestSort" :key="option.id">
                    <input
                      :id="option.id"
                      class="multiselectOption"
                      :class="{
                        isPercentShow: option.value == 'Discount' && isPercentDiscount == false,
                      }"
                      type="radio"
                      name="sort"
                      :checked="option.id == 'sort1' ? true : false"
                      :value="option.value"
                      @change="onCheckSort($event)"
                    />
                    <label
                      class="optionLabel"
                      :class="{
                        isPercentShow: option.value == 'Discount' && isPercentDiscount == false,
                      }"
                      :for="option.id"
                      @click="
                        (event) => {
                          closeSortMenu(event);
                        }
                      "
                      >{{ option.text }}</label
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Filter Row End -->

  <!-- Product Grid Start -->
  <div class="product_grid modify-slider">
    <div
      class="grid_inner product-containers"
      :class="{ grid_inner_max: gridMax, grid_inner_min: gridMin }"
    >
      <div v-for="(value, key) in uniqueProducts" :key="key" class="product_item">
        <!-- this block work for single product products -->
        <div v-if="value?.hasOwnProperty('single')" class="card">
          <a :href="`/products/` + value?.single.handle">
            <div
              :id="`item_left_` + value?.single.handle"
              class="item_left"
              :class="{
                item_left_active: value?.single.variants[0].inStock < 5,
              }"
            >
              {{
                value?.single.variants[0].inStock <= 5 && value?.single.variants[0].inStock >= 1
                  ? 'ONLY ' + value?.single.variants[0].inStock + ' LEFT'
                  : value?.single.variants[0].inStock == 0
                    ? 'SOLD OUT'
                    : ''
              }}
            </div>

            <div v-if="value?.single.images.length > 1" class="product_img_wrapper">
              <img
                v-lazy="value?.single.featured_image"
                alt="Product Image"
                loading="eager"
                fetchpriority="high"
                decoding="async"
                aria-label="Product Image"
                width="627"
                :value="value?.single.images"
                class="normal 1s"
              />
              <img
                v-lazy="value?.single.images[1]"
                alt="Product Image"
                loading="eager"
                fetchpriority="high"
                decoding="async"
                aria-label="Product Image"
                width="627"
                :value="value?.single.images"
                class="hoverImg 1s"
              />
            </div>

            <div v-else-if="value?.single?.images?.length == 1" class="product_img_wrapper">
              <img
                v-lazy="value?.single?.featured_image"
                alt="Product Image"
                loading="eager"
                fetchpriority="high"
                decoding="async"
                aria-label="Product Image"
                width="627"
                :value="value?.single"
                class="normal 1s"
              />
            </div>
            <div v-else class="product_img_wrapper">
              <img
                src="https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png"
                alt="Placeholder Product Image"
                loading="lazy"
                fetchpriority="high"
                decoding="async"
                aria-label="Placeholder Product Image"
                width="627"
                class="normal"
              />
            </div>

            <h3 class="card-title product_title">
              {{ cleanTitle(value?.single.title) }}
            </h3>

            <span class="card-title bold product_price">
              <span
                v-if="value.single.price && value.single.compare_at_price"
                class="tmb_product_price"
              >
                <span class="tmb_original_price">
                  <del>
                    {{ currencySymbol + (value.single.compare_at_price / 100).toFixed(2) }}
                  </del>
                </span>

                <span class="tmb_discounted">
                  {{ currencySymbol + (value.single.price / 100).toFixed(2) }}
                </span>

                <span class="discount-percentage">
                  {{
                    Math.round(
                      ((value.single.compare_at_price - value.single.price) /
                        value.single.compare_at_price) *
                        100
                    )
                  }}% off
                </span>
              </span>

              <span v-else>
                {{ currencySymbol + (value.single.price / 100).toFixed(2) }}
              </span>
            </span>
          </a>

          <div class="quickButton quickActive">
            <div class="color_swatches" />
            <div class="product_cta_wrapper qwert">
              <!-- if quantity is 0 then hide -->

              <span v-if="value?.single.variants[0].inStock != 0">
                <button
                  :id="'quickAdd' + value?.single.id"
                  class="quickAdd"
                  :variantid="value?.single.variants[0].id"
                  aria-label="Add to Cart"
                  @click="addToCard"
                >
                  <span>Add</span>
                  <div class="loder_tmb">
                    <span /><span /> <span /><span />
                    <span />
                  </div>
                </button>
              </span>
            </div>
          </div>
        </div>

        <!-- this block work for variable product products -->

        <div
          v-if="value?.hasOwnProperty('variable') && value?.variable.length - 1 >= value?.active"
          class="card"
        >
          <a :href="`/products/` + value?.variable[value.active].handle">
            <div
              :id="`item_left_` + value?.variable[value.active].handle"
              class="item_left"
              :class="{
                item_left_active: value?.variable[value.active].variants[0].inStock < 5,
              }"
            >
              {{
                value?.variable[value.active].variants[0].inStock <= 5 &&
                value?.variable[value.active].variants[0].inStock >= 1
                  ? 'ONLY ' + value?.variable[value.active].variants[0].inStock + ' LEFT'
                  : value?.variable[value.active].variants[0].inStock == 0
                    ? 'SOLD OUT'
                    : ''
              }}
            </div>

            <div
              v-if="value?.variable[value.active]?.images?.length > 2"
              id="product_img_wrapper6617090588769"
              class="product_img_wrapper collection-all-page-image-wrapper"
            >
              <img
                :src="value?.variable[value.active]?.featured_image"
                alt="Product Image"
                loading="eager"
                fetchpriority="high"
                decoding="async"
                aria-label="Product Image"
                class="normal 1"
              />
              <img
                v-lazy="value?.variable[value.active]?.images[1]"
                alt="Product Image"
                loading="eager"
                fetchpriority="high"
                decoding="async"
                aria-label="Product Image"
                class="hoverImg 1"
              />
            </div>
            <div
              v-else-if="value?.variable[value.active]?.images?.length == 1"
              id="product_img_wrapper6617090588769"
              class="product_img_wrapper"
            >
              <img
                v-lazy="value?.variable[value.active]?.featured_image"
                alt="Product Image"
                loading="eager"
                fetchpriority="high"
                decoding="async"
                aria-label="Product Image"
                width="627"
                class="normal 0"
              />
            </div>
            <div v-else class="product_img_wrapper">
              <img
                src="https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png"
                alt="Placeholder Product Image"
                loading="lazy"
                aria-label="Placeholder Product Image"
                width="627"
                class="normal 0"
              />
            </div>

            <h3 class="card-title product_title">
              {{ cleanTitle(value?.variable[value.active]?.title) }}
            </h3>

            <div class="card-title bold product_price">
              <div
                v-if="
                  value?.variable[value.active].price &&
                  value?.variable[value.active].compare_at_price
                "
                class="tmb_product_price collection-product-card-price-container"
              >
                <span class="tmb_original_price">
                  <del>
                    {{
                      currencySymbol +
                      ' ' +
                      (value?.variable[value.active].compare_at_price / 100).toFixed(2)
                    }}
                  </del>
                </span>

                <span class="tmb_discounted">
                  {{
                    currencySymbol + ' ' + (value?.variable[value.active].price / 100).toFixed(2)
                  }}
                </span>

                <span class="discount-percentage">
                  {{
                    Math.round(
                      ((value?.variable[value.active].compare_at_price -
                        value?.variable[value.active].price) /
                        value?.variable[value.active].compare_at_price) *
                        100
                    )
                  }}% off
                </span>
              </div>

              <span v-else>
                {{ currencySymbol + ' ' + (value?.variable[value.active].price / 100).toFixed(2) }}
              </span>
            </div>
          </a>

          <div class="quickButton quickActive">
            <div
              class="color_swatches"
              :class="[value.swatches.length <= 4 ? 'not-slider' : 'tmbSlider']"
            >
              <swiper
                class="swatches_inner mySwiper"
                :slides-per-view="'auto'"
                :space-between="7"
                :navigation="true"
                :modules="modules"
                :main-key="JSON.stringify(value)"
              >
                <!-- @slideChange="sunny" -->
                <swiper-slide
                  v-for="(sValue, sKey) in value?.swatches"
                  :key="sKey"
                  :index="sKey"
                  :link="sValue.link"
                  class="nav-dots"
                  :active-index="sKey == value?.active ? 'true' : 'false'"
                  :class="sKey == value?.active ? 'active' : ''"
                  @click="selectVariation"
                >
                  <span>
                    <!-- v-lazy="getThemeAssets(svalue?.img, value?.variable[value?.active].swatchesImage)" -->
                    <img
                      v-lazy="sValue?.url[0]?.[sValue?.img]"
                      :index="sKey"
                      :class="sValue?.img"
                      :xyz="sValue?.url[0]?.[sValue?.img]"
                      :status="sValue?.status.status"
                      class="swatchesHide"
                      :alt="sValue?.url[0]?.[sValue?.img]"
                      loading="lazy"
                      aria-hidden="true"
                      aria-label="Product Image"
                      width="20"
                      height="20"
                    />
                  </span>
                </swiper-slide>
              </swiper>
            </div>
            <div class="product_cta_wrapper" data-v-32bfb114="">
              <button
                :id="'quickAdd' + value?.variable[value.active].id"
                :class="{
                  quickAdd_deactive: value?.variable[value.active].variants[0].inStock == 0,
                }"
                :variantid="value?.variable[value.active].variants[0].id"
                qty="1"
                class="quickAdd"
                aria-label="Add to Cart"
                @click="addToCard"
              >
                <span>Add</span>
                <div class="loder_tmb">
                  <span /><span /> <span /><span />
                  <span />
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="loader">
      <span />
      <span />
      <span />
      <span />
      <span />
    </div>

    <!-- Load More Button -->
    <div v-if="hasNextPage && Products.length > 0" class="load-more-wrapper">
      <button
        class="load-more-btn"
        :disabled="isLoadingMore"
        aria-label="Load More Products"
        @click="loadMoreProducts"
      >
        <span v-if="!isLoadingMore">Load More Products</span>
        <span v-else>Loading...</span>
      </button>
    </div>

    <div
      class="row centeralign addmargin"
      :class="{
        productnotfound: Products.length === 0,
        productfound: Products.length > 0,
      }"
    >
      <h2 class="sec_heading">We're sorry, no matches were found.</h2>
      <h4 class="body_text">
        We couldn't find any results for your selected filters. Clear your filters or contact our
        Client Services Team at
        <a href="mailto:clientservices@behno.com">clientservices@behno.com</a> and we'll be happy to
        help.
      </h4>
    </div>
  </div>

  <!-- Footer Banner Section -->
  <!-- <div v-if="decodedShopifyData.footerBannerHeading || decodedShopifyData.footerBannerContent"
    class="footer_banner_section">
    <div class="footer_banner_content">
      <h2 v-if="
        decodedShopifyData.footerBannerHeading &&
        decodedShopifyData.footerBannerHeading.length > 0
      " class="footer_banner_heading">
        {{ decodedShopifyData.footerBannerHeading }}
      </h2>
      <div v-if="decodedShopifyData.footerBannerContent && decodedShopifyData.footerBannerContent.length > 0"
        class=" footer_banner_description_wrapper">
        <p class="footer_banner_description" :class="{ truncated: !showFullContent && shouldTruncate }">
          {{ decodedShopifyData.footerBannerContent }}
        </p>
      </div> -->

  <!-- Additional banner content revealed on Read More -->
  <!-- <div v-if="showFullContent" class="footer_banner_additional">
        <template v-if="footerContent3Html">
          <p class="footer_banner_description footer_banner_rich_content" v-html="sanitizeHtml(footerContent3Html)" />
        </template>
      </div>
    </div>
  </div> -->

  <div
    v-if="footerBannerHeadingDecoded || footerBannerContentDecoded"
    class="footer_banner_section"
  >
    <div class="footer_banner_content">
      <h2 v-if="footerBannerHeadingDecoded.length > 0" class="footer_banner_heading">
        {{ footerBannerHeadingDecoded }}
      </h2>

      <!-- <div v-if="footerBannerContentDecoded.length > 0" class="footer_banner_description_wrapper">
        <p
          class="footer_banner_description"
          :class="{ truncated: !showFullContent && shouldTruncate }"
        >
          {{ footerBannerContentDecoded }}
        </p>
      </div> -->

      <div
        v-if="footerBannerContentLinkDecoded.length > 0"
        class="footer_banner_description_wrapper"
      >
        <div
          ref="footerDescription"
          class="footer_banner_description"
          v-html="footerBannerContentLinkDecoded"
        ></div>
        <button
          v-if="shouldTruncate"
          class="readMoreButton"
          :aria-expanded="showFullContent"
          @click="toggleContent"
        >
          {{ showFullContent ? 'Read Less' : 'Read More' }}
        </button>
      </div>

      <!-- Additional banner content revealed on Read More -->
      <div v-if="showFullContent" class="footer_banner_additional">
        <template v-if="footerContent3Html">
          <p
            class="footer_banner_description footer_banner_rich_content"
            v-html="sanitizeHtml(footerContent3Html)"
          />
        </template>
      </div>
    </div>
  </div>
  <!-- FAQ Section -->
  <div v-if="parsedFaqItems && parsedFaqItems.length > 0" class="faq-section">
    <h2 class="faq-heading">FREQUENTLY ASKED QUESTIONS</h2>
    <div v-for="(faq_item, index) in parsedFaqItems" :key="index" class="faq-item">
      <button class="faq-question" aria-label="Toggle FAQ Answer" @click="toggleAnswer(index)">
        <span class="faq-icon" :class="{ expanded: shownAnswerIndex === index }">
          <svg
            v-if="shownAnswerIndex !== index"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M7 1V13M1 7H13" stroke="black" stroke-width="1.5" stroke-linecap="square" />
          </svg>
          <svg
            v-else
            width="14"
            height="2"
            viewBox="0 0 14 2"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M1 1H13" stroke="black" stroke-width="1.5" stroke-linecap="square" />
          </svg>
        </span>
        <span class="faq-question-text">{{ faq_item.question }}</span>
      </button>
      <div v-if="shownAnswerIndex === index" class="faq-answer">
        {{ faq_item.answer }}
      </div>
    </div>
  </div>
  <!-- Footer Banner Section End -->
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import { Navigation } from 'swiper';
import { sanitizeHtml } from '@/sanitizeContent.js';
import { ShopifyAPI } from '../../Shopify/Shopify';
import { currencyJson } from '@/currency';

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    shopifyData: {
      type: Object,
      required: false,
    },
    shopifyDataEncoded: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      modules: [Navigation],
      categoryRules: [],
      colorRules: [],
      cizeRules: [],
      materialRules: [],
      isPercentDiscount: true,
      isActive: false,
      isMobile: false,
      gridMax: false,
      gridMin: false,
      show: false,
      showSort: false,
      showColor: false,
      showSize: false,
      showMaterial: false,
      selected: [],
      selectedFilter: [],
      selectedSort: ['Recommended'],
      selectedColor: [],
      selectedSize: [],
      selectedMaterial: [],
      ddTestCategory: this.getCategoryDropDownList(),
      ddTestColor: this.getColorDropDownList(),
      ddTestSize: this.getSizeDropDownList(),
      ddTestMaterial: this.getMaterialDropDownList(),
      page_index: 0,
      filterByCategory: [],
      filterByColor: [],
      filterBySize: [],
      filterByMaterial: [],
      busy: false,
      showClearAll: false,
      gridColumn: 6,
      productId: 0,
      priceSort: '',
      ddTestSort: [
        {
          id: 'sort1',
          value: 'Recommended',
          text: 'Recommended',
        },
        {
          id: 'sort2',
          value: 'LowToHigh',
          text: 'Price: Low to High',
        },
        {
          id: 'sort3',
          value: 'HighToLow',
          text: 'Price: High to Low',
        },
        {
          id: 'sort4',
          value: 'Latest',
          text: 'Latest Arrivals',
        },
        {
          id: 'sort5',
          value: 'Discount',
          text: 'Percent Discount',
        },
      ],
      sortObject: {},
      selectedSortPercent: [],
      selectedNewArrival: '',
      setDefaultProduct: [],
      Products: [],
      ProductsRaw: [],
      diagnostics: [],
      debugOpen: false,
      AllProducts: [],
      ErrorCase: false,
      shopifyPagination: false,
      themeAssets: [],
      hideCategorydropdown: 1,
      hideAllCategorydropdown: false,
      loadInit: false,
      activeSwatchIndex: '0',
      currencySymbol: currencyJson[window?.Shopify?.currency?.active]?.symbol_native,
      showFullContent: false,
      shouldTruncate: false,
      contentCharLimit: 400, // Adjust this number to control when "READ MORE" appears
      currentPage: 1,
      totalPages: 1,
      hasNextPage: false,
      isLoadingMore: false,
      allLoadedProducts: [], // Store all products from all pages
      collectionListingData: '', // Local copy of collection listing data
      shownAnswerIndex: 0, // First FAQ open by default
    };
  },
  computed: {
    parsedFaqItems() {
      try {
        const shopifyData = this.decodedShopifyData || this.shopifyData || {};
        if (!shopifyData.faqItems) {
          // console.log('No FAQ items found in shopifyData');
          return [];
        }
        // console.log('FAQ items found, decoding...');
        const decoded = window.atob(shopifyData.faqItems);
        const parsed = JSON.parse(decoded);
        // console.log('Parsed FAQ items:', parsed);
        return parsed;
      } catch (e) {
        console.error('Failed to parse FAQ items:', e);
        return [];
      }
    },
    decodedShopifyData() {
      // Decode base64-encoded shopifyData if provided, otherwise use direct prop
      if (this.shopifyDataEncoded) {
        try {
          const decoded = window.atob(this.shopifyDataEncoded);
          // console.log("Decoded shopifyData:", decoded);
          const parsed = JSON.parse(decoded);
          // console.log("Parsed shopifyData:", parsed);
          return parsed;
        } catch (e) {
          console.error('Error decoding shopifyData:', e);
          return this.shopifyData || {};
        }
      }
      return this.shopifyData || {};
    },
    // ✅ Single UTF-8 safe Base64 decoder
    decodeBase64Utf8() {
      return (str) => {
        try {
          return decodeURIComponent(escape(window.atob(str)));
        } catch {
          return str || '';
        }
      };
    },

    // ✅ Reusable field decoder
    decodeField() {
      return (value, asBoolean = false) => {
        try {
          const decoded = value ? this.decodeBase64Utf8(value) : '';
          if (asBoolean) return decoded === 'true';
          return decoded;
        } catch {
          if (asBoolean) return value === true || value === 'true';
          return value || '';
        }
      };
    },

    // ✅ Field decoders
    footerBannerHeadingDecoded() {
      return this.decodeField(this.decodedShopifyData.footerBannerHeading);
    },
    footerBannerContentDecoded() {
      return this.decodeField(this.decodedShopifyData.footerBannerContent);
    },

    footerBannerContentLinkDecoded() {
      const decoded = this.decodeField(this.decodedShopifyData.footerBannerContentLink);

      try {
        const parsed = JSON.parse(decoded);
        return this.richTextToHtml(parsed);
      } catch (e) {
        // console.error('JSON Parse Error:', e);
        // console.log('Decoded value:', decoded);
        return decoded;
      }
    },
    bannerHeadingDecoded() {
      return this.decodeField(this.decodedShopifyData.bannerHeading);
    },
    renderHeroDecoded() {
      return this.decodeField(this.decodedShopifyData.renderHero, true);
    },

    uniqueProducts() {
      const seen = new Set();
      const filtered = this.Products.filter((product) => {
        const title = product?.single?.title || product?.variable?.[product.active]?.title;
        if (seen.has(title)) {
          console.log('🔄 Duplicate found:', title);
          return false; // skip duplicates
        }
        seen.add(title);
        return true;
      });
      console.log(`🎨 uniqueProducts: ${filtered.length} of ${this.Products.length} total`);
      return filtered;
    },
    ProductsRawPreview() {
      try {
        if (!this.ProductsRaw) return '';
        const s = JSON.stringify(this.ProductsRaw);
        return s.length > 2000 ? s.substring(0, 2000) + '...' : s;
      } catch (e) {
        return '(preview unavailable)';
      }
    },
    shouldShowDebug() {
      try {
        // show debug if not production build OR running on localhost OR explicit ?debug=1 param
        if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV !== 'production')
          return true;
        if (typeof window !== 'undefined') {
          const host = window.location.hostname;
          if (host === 'localhost' || host === '127.0.0.1') return true;
          try {
            const params = new URLSearchParams(window.location.search);
            if (params.get('debug') === '1') return true;
          } catch (e) {
            // ignore
          }
        }
      } catch (e) {
        return false;
      }
      return false;
    },
  },
  watch: {
    footerBannerContentLinkDecoded() {
      this.$nextTick(this.checkFooterContent);
    },
  },
  mounted() {
    this.currencySymbol = currencyJson[window?.Shopify?.currency?.active]?.symbol_native;

    if (window.innerWidth <= 767) {
      this.isMobile = true;
    }

    this.$nextTick(this.checkFooterContent);

    // Get decoded shopify data
    const shopifyData = this.decodedShopifyData;

    // Debug FAQ data
    // console.log('🔍 Checking FAQ data in mounted...');
    // console.log('FAQ Items raw:', shopifyData.faqItems);
    // console.log('Parsed FAQ Items:', this.parsedFaqItems);

    // Initialize pagination data
    this.currentPage = shopifyData.currentPage || 1;
    this.totalPages = shopifyData.totalPages || 1;
    this.hasNextPage = shopifyData.hasNextPage || false;

    // Initialize local copy of collection listing data
    if (!this.collectionListingData && shopifyData.collectionListing) {
      this.collectionListingData = shopifyData.collectionListing;
    }

    // this.showcollectionBanner()
    this.hideCategoryDropdown();
    this.filterStorage();
    this.fetchProdustQuery();
    this.setScreenRangeGrid();
    this.roughData();
    this.loadInit = true;
    this.hideAllFillterDropdown();

    window.addEventListener('load', () => {
      const tmbSliderCtaNext = document.querySelectorAll('.tmbSlider .swiper-button-next');
      const tmbSliderCtaPrev = document.querySelectorAll('.tmbSlider .swiper-button-prev');
      // next button Click
      for (const i of tmbSliderCtaNext) {
        i.addEventListener('click', () => {
          i.closest('.tmbSlider')?.classList.add('removeMargin');
        });
      }
      // prev Button click

      for (const i of tmbSliderCtaPrev) {
        i.addEventListener('click', () => {
          if (i.matches('.swiper-button-disabled')) {
            i.closest('.tmbSlider')?.classList.remove('removeMargin');
          }
        });
      }
    });
  },

  methods: {
    sanitizeHtml,

    // 🔒 Safe DOM helpers (most important for crash-free code)

    richTextToHtml(node) {
      if (!node) return '';

      if (Array.isArray(node)) {
        return node.map((child) => this.richTextToHtml(child)).join('');
      }

      switch (node.type) {
        case 'root':
          return this.richTextToHtml(node.children);

        case 'paragraph':
          return `<p>${this.richTextToHtml(node.children)}</p>`;

        case 'text': {
          let text = node.value || '';

          if (node.bold) text = `<strong>${text}</strong>`;

          if (node.italic) text = `<em>${text}</em>`;

          return text;
        }

        case 'link':
          return `<a href="${node.url}">
                ${this.richTextToHtml(node.children)}
            </a>`;

        default:
          return '';
      }
    },

    safeQuery(selector, root = document) {
      if (!root) return null;
      try {
        return root.querySelector(selector);
      } catch {
        return null;
      }
    },
    safeQueryAll(selector, root = document) {
      if (!root) return [];
      try {
        return root.querySelectorAll(selector) || [];
      } catch {
        return [];
      }
    },
    safeId(id) {
      try {
        return document.getElementById(id) || null;
      } catch {
        return null;
      }
    },

    // Toggle FAQ answer visibility
    toggleAnswer(index) {
      this.shownAnswerIndex = this.shownAnswerIndex === index ? -1 : index;
    },

    cleanTitle(str) {
      if (!str) return '';
      return str
        .normalize('NFC') // encoding normalize
        .replaceAll('Â°', '°') // common Shopify encoding fix
        .replaceAll('Â', ''); // extra broken byte cleanup
    },
    // Helper method to get shopify data during initialization or runtime
    getShopifyData() {
      // Try computed property first (available after initialization)
      if (this.decodedShopifyData && Object.keys(this.decodedShopifyData).length > 0) {
        // console.log('✅ Using decodedShopifyData (computed)');
        return this.decodedShopifyData;
      }

      // Fallback for initialization phase when computed isn't ready yet
      if (this.shopifyDataEncoded) {
        // console.log('🔄 Decoding shopifyDataEncoded prop');
        try {
          const decoded = window.atob(this.shopifyDataEncoded);
          return JSON.parse(decoded);
        } catch (e) {
          console.error('Error decoding shopifyData:', e);
          return this.shopifyData || {};
        }
      }

      // console.log('⚠️ Using fallback shopifyData prop');
      return this.shopifyData || {};
    },
    // hideAllFillterDropdown() {
    //   const shopifyData = this.getShopifyData();
    //   const blackListPage = JSON.parse(window.atob(shopifyData.hidefiltercollection || '[]'));
    //   const url = window.location.pathname;
    //   const parts = url.split('/');
    //   const last_part = parts[parts.length - 1];
    //   if (blackListPage && blackListPage.includes(last_part)) {
    //     this.hideAllCategorydropdown = true;
    //   }
    // },

    hideAllFillterDropdown() {
      const shopifyData = this.getShopifyData();
      const raw = shopifyData.hidefiltercollection || '[]';
      let blackListPage = [];

      try {
        blackListPage = JSON.parse(window.atob(raw));
      } catch (e) {
        console.error('Error parsing hidefiltercollection:', e);
      }

      const url = window.location.pathname;
      const parts = url.split('/');
      const last_part = parts[parts.length - 1];

      if (blackListPage && blackListPage.includes(last_part)) {
        this.hideAllCategorydropdown = true;
      }
    },

    // hideCategoryDropdown() {
    //   const shopifyData = this.getShopifyData();
    //   const blackListPage = JSON.parse(window.atob(shopifyData.hidecollection || '[]'));
    //   const url = window.location.pathname;
    //   const parts = url.split('/');
    //   const last_part = parts[parts.length - 1];
    //   if (blackListPage && blackListPage.includes(last_part)) {
    //     this.hideCategorydropdown = 0;
    //   }
    // },

    hideCategoryDropdown() {
      const shopifyData = this.getShopifyData();
      const raw = shopifyData.hidecollection || '[]';
      let blackListPage = [];

      try {
        blackListPage = JSON.parse(window.atob(raw));
      } catch (e) {
        console.error('Error parsing hidecollection:', e);
      }

      const url = window.location.pathname;
      const parts = url.split('/');
      const last_part = parts[parts.length - 1];
      if (blackListPage && blackListPage.includes(last_part)) {
        this.hideCategorydropdown = 0;
      }
    },
    // filterStorage() {
    //   const arr = [];
    //   localStorage.setItem('fillters', arr);
    // },
    filterStorage() {
      const arr = [];
      try {
        localStorage.setItem('fillters', JSON.stringify(arr));
      } catch (e) {
        console.warn('localStorage not available:', e);
      }
    },
    // rough data decoder function
    roughData() {
      const shopifyData = this.getShopifyData();
      const collectionListing = this.collectionListingData || shopifyData.collectionListing || '';

      if (!collectionListing) {
        return [];
      }

      try {
        const productData = window.atob(collectionListing);
        const products = JSON.parse(productData);
        return products;
      } catch (e) {
        console.error('Error parsing product data:', e);
        return [];
      }
    },
    // select sort option and close sort menu
    // closeSortMenu(event) {
    //     if (event.target.closest('.show') != null) {
    //       event.target.closest('.show').classList.remove('show');
    //     }
    // },

    closeSortMenu(event) {
      const parent = event?.target?.closest('.show');
      if (parent) {
        parent.classList.remove('show');
      }
    },
    // add active class to selected color
    addActive(event) {
      event.currentTarget?.classList?.toggle('active');
    },
    // close dropdown filter
    // closeDropDown(show, type) {
    //   if (type == 'show') {
    //     if (show == true) {
    //       this.show = false;
    //     } else {
    //       this.show = true;
    //     }
    //   }
    //   if (type == 'showColor') {
    //     if (show == true) {
    //       this.showColor = false;
    //     } else {
    //       this.showColor = true;
    //     }
    //   }
    //   if (type == 'showSize') {
    //     if (show == true) {
    //       this.showSize = false;
    //     } else {
    //       this.showSize = true;
    //     }
    //   }
    //   if (type == 'showMaterial') {
    //     if (show == true) {
    //       this.showMaterial = false;
    //     } else {
    //       this.showMaterial = true;
    //     }
    //   }
    // },
    closeDropDown(show, type) {
      if (type === 'show') {
        this.show = !show;
      } else if (type === 'showColor') {
        this.showColor = !show;
      } else if (type === 'showSize') {
        this.showSize = !show;
      } else if (type === 'showMaterial') {
        this.showMaterial = !show;
      }
    },
    // open filter navbar
    // myFilter() {
    //   const filters = document.querySelector('.filters');
    //   const applyfilters = document.querySelector('.apply_filter_cta_wrapper');
    //   applyfilters.classList.add('show');
    //   filters.classList.toggle('show');
    // },

    myFilter() {
      const filters = this.safeQuery('.filters');
      const applyfilters = this.safeQuery('.apply_filter_cta_wrapper');
      applyfilters && applyfilters.classList.add('show');
      filters && filters.classList.toggle('show');
    },

    // open sortBy navbar
    // sortBy() {
    //   const sortBy = document.querySelector('.sort_by');
    //   sortBy.classList.toggle('show');
    // },
    sortBy() {
      const sortBy = this.safeQuery('.sort_by');
      sortBy && sortBy.classList.toggle('show');
    },

    // close navbar
    // closeMenu(e) {
    //   const activeMenu = e.currentTarget.closest('.show');
    //   activeMenu.classList.remove('show');
    //   const applyfilters = document.querySelector('.apply_filter_cta_wrapper');
    //   applyfilters.classList.remove('show');
    // },
    closeMenu(e) {
      const activeMenu = e?.currentTarget?.closest('.show');
      if (activeMenu) {
        activeMenu.classList.remove('show');
      }

      const applyfilters = this.safeQuery('.apply_filter_cta_wrapper');
      applyfilters && applyfilters.classList.remove('show');
    },

    // apply filter and close filter
    // applyfilter() {
    //   const applyfilters = document.querySelector('.apply_filter_cta_wrapper.show');
    //   const applyfilterShow = document.querySelector('.filters.show');
    //   applyfilters.classList.remove('show');
    //   applyfilterShow.classList.remove('show');
    // },
    applyfilter() {
      const applyfilters = this.safeQuery('.apply_filter_cta_wrapper.show');
      const applyfilterShow = this.safeQuery('.filters.show');
      applyfilters && applyfilters.classList.remove('show');
      applyfilterShow && applyfilterShow.classList.remove('show');
    },

    // cardmouseleave function to remove active class from quick add button

    // cardmouseleave(id) {
    //   this.productId = 0;
    //   const quickAdd = document.querySelector('#quickAdd' + id);
    //   quickAdd.classList.remove('quickAdd_active');
    // },
    cardmouseleave(id) {
      this.productId = 0;
      const quickAdd = this.safeQuery('#quickAdd' + id);
      quickAdd && quickAdd.classList.remove('quickAdd_active');
    },

    // inlineBgImage function to set background image for color swatches
    // inlineBgImage(colors) {
    //   const color = colors.toLowerCase().replace(/[^A-Z0-9]+/gi, '-');
    //   const bgImage =
    //     '//cdn.shopify.com/s/files/1/0899/2182/files/' + color + '.png?v=5251390435792914590';

    //   const url = `background-image:url(${bgImage});`;
    //   return url + 'background:' + color;
    // },
    inlineBgImage(colors) {
      const color = colors.toLowerCase().replace(/[^A-Z0-9]+/gi, '-');
      const bgImage =
        '//cdn.shopify.com/s/files/1/0899/2182/files/' + color + '.png?v=5251390435792914590';

      const url = `background-image:url(${bgImage});`;
      return url + 'background:' + color;
    },

    // onSelectColor function to set active color and add to cart
    // onSelectColor(color, product, event) {
    //   // console.log(product.id);
    //   if (event.currentTarget.parentElement.children.length > 1) {
    //     const childcolor = event.currentTarget.parentElement.children;
    //     for (const item of childcolor) {
    //       item.classList.remove('activecolor');
    //     }
    //   }
    //   event.currentTarget.classList.add('activecolor');
    //   const img = document.getElementById(product.id);
    //   const div = document.querySelector('#item_left_' + product.id);
    //   const product_img_div = document.querySelector('#product_img_wrapper' + product.id);
    //   const out_of_stock_text = document.querySelector('#out_of_stock_text' + product.id);
    //   const quickAdd = document.querySelector('#quickAdd' + product.id);

    //   // console.log(img);
    //   const varints = product.variants.filter((item) => {
    //     return item.title && item.title.includes(color);
    //   });
    //   if (varints.length > 0) {
    //     if (varints[0].featured_image != null) {
    //       // console.log(varints[0].featured_image.src);
    //       img.src = varints[0].featured_image.src;
    //     }
    //     div.textContent = varints[0].stock <= 5 ? 'ONLY ' + varints[0].stock + ' LEFT' : '';

    //     if (varints[0].stock == 0) {
    //       div.textContent = 'SOLD OUT';
    //       out_of_stock_text.classList.add('out_of_stock_text_active');
    //       product_img_div.classList.add('out_of_stock');
    //       quickAdd.classList.remove('quickAdd_active');
    //       quickAdd.classList.add('quickAdd_deactive');
    //     } else {
    //       out_of_stock_text.classList.remove('out_of_stock_text_active');
    //       product_img_div.classList.remove('out_of_stock');
    //       quickAdd.classList.remove('quickAdd_deactive');
    //       quickAdd.classList.add('quickAdd_active');
    //     }
    //   }
    // },

    onSelectColor(color, product, event) {
      this.fetchProdustQuery();
      // console.log(product.id);
      if (event?.currentTarget?.parentElement?.children?.length > 1) {
        const childcolor = event.currentTarget.parentElement.children;
        for (const item of childcolor) {
          item.classList.remove('activecolor');
        }
      }
      event.currentTarget?.classList?.add('activecolor');
      const img = this.safeId(product.id);
      const div = this.safeQuery('#item_left_' + product.id);
      const product_img_div = this.safeQuery('#product_img_wrapper' + product.id);
      const out_of_stock_text = this.safeQuery('#out_of_stock_text' + product.id);
      const quickAdd = this.safeQuery('#quickAdd' + product.id);

      // console.log(img);
      const varints = product.variants.filter((item) => {
        return item.title && item.title.includes(color);
      });
      if (varints.length > 0) {
        const variant = varints[0];
        if (variant.featured_image && img) {
          img.src = variant.featured_image.src;
        }
        if (div) {
          div.textContent = variant.stock <= 5 ? 'ONLY ' + variant.stock + ' LEFT' : '';
        }

        if (varints[0].stock == 0) {
          if (div) div.textContent = 'SOLD OUT';
          out_of_stock_text && out_of_stock_text.classList.add('out_of_stock_text_active');
          product_img_div && product_img_div.classList.add('out_of_stock');
          if (quickAdd) {
            quickAdd.classList.remove('quickAdd_active');
            quickAdd.classList.add('quickAdd_deactive');
          }
        } else {
          out_of_stock_text && out_of_stock_text.classList.remove('out_of_stock_text_active');
          product_img_div && product_img_div.classList.remove('out_of_stock');
          if (quickAdd) {
            quickAdd.classList.remove('quickAdd_deactive');
            quickAdd.classList.add('quickAdd_active');
          }
        }
      }
    },

    /* change images on hover */
    mouseover(event, imgsrc) {
      if (event?.target) {
        event.target.src = imgsrc;
      }
    },
    // change images on hover
    mouseleave(event, imgsrc) {
      if (event?.target) {
        event.target.src = imgsrc;
      }
    },
    /* end change images on hover */

    /* change grid column */
    setScreenRangeGrid() {
      const width = window.innerWidth;
      if (width > 2000) {
        this.gridColumn = 6;
      } else if (width > 767 && width < 2000) {
        this.gridColumn = 4;
      } else {
        this.gridColumn = 2;
      }
    },

    sliderChangeManully(e) {
      // console.log(e)
      let values = this.gridColumn;

      if (e === 'nagtive' && values >= 2) {
        console.log(values, 'sliderChangeManully');
        values = parseInt(values) - 2;
      } else if (e === 'postive') {
        values = parseInt(values) + 2;
        console.log(values, 'sliderChangeManully');
      }
      // console.log(values)
      if (Math.sign(values) === -1) {
        this.gridColumn = 2;
        return;
      } else if (values > 6) {
        this.gridColumn = 6;
        return;
      }
      this.gridColumn = values;
      document.getElementById('ageInputId').value = this.gridColumn;

      if (values <= 2) {
        this.gridMin = false;
        this.gridMax = true;
      } else if (values == 6) {
        this.gridMin = true;
        this.gridMax = false;
      } else {
        this.gridMin = false;
        this.gridMax = false;
      }
    },

    sliderChange(event) {
      if (event.target.value == 2) {
        this.gridMin = false;
        this.gridMax = true;
      } else if (event.target.value == 6) {
        this.gridMin = true;
        this.gridMax = false;
      } else {
        this.gridMin = false;
        this.gridMax = false;
      }
    },

    /* Clear all filter */
    clearAllFilter() {
      this.selected = [];
      this.selectedColor = [];
      this.selectedSize = [];
      this.selectedMaterial = [];
      this.showClearAll = false;
      this.clearCheckBoxs('category');
      this.clearCheckBoxs('color');
      this.clearCheckBoxs('size');
      this.clearCheckBoxs('material');
      this.fetchProdustQuery();
    },
    /* End Clear all filter */

    /* start unchecked checkbox when click clear button in dropdown */
    // clearCheckBoxs(name) {
    //   const markedCheckbox = document.getElementsByName(name);
    //   for (const checkbox of markedCheckbox) {
    //     if (checkbox.checked) checkbox.checked = false;
    //   }

    //   let savedFilter = [];
    //   const savedItem = localStorage.getItem('fillters') || [];
    //   let category, size, material, color, sort;
    //   category = -1;
    //   size = -1;
    //   material = -1;
    //   color = -1;
    //   sort = -1;
    //   if (savedItem != '') {
    //     savedFilter = JSON.parse(savedItem);
    //     savedFilter.map((e, i) => {
    //       if (Object.prototype.hasOwnProperty.call(e, 'Category')) {
    //         category = i;
    //       } else if (Object.prototype.hasOwnProperty.call(e, 'Color')) {
    //         color = i;
    //       } else if (Object.prototype.hasOwnProperty.call(e, 'Size')) {
    //         size = i;
    //       } else if (Object.prototype.hasOwnProperty.call(e, 'Material')) {
    //         material = i;
    //       } else if (Object.prototype.hasOwnProperty.call(e, 'sort')) {
    //         sort = i;
    //       }
    //     });
    //   }

    //   if (name == 'category') {
    //     this.selected = [];
    //     this.filterByCategory = [];
    //     if (category >= 0) {
    //       savedFilter.splice(parseInt(category), parseInt(savedFilter.length));
    //     }
    //   } else if (name == 'color') {
    //     this.selectedColor = [];
    //     this.filterByColor = [];
    //     if (color >= 0) {
    //       savedFilter.splice(parseInt(color), parseInt(savedFilter.length));
    //     }
    //   } else if (name == 'size') {
    //     this.selectedSize = [];
    //     this.filterBySize = [];
    //     if (size >= 0) {
    //       savedFilter.splice(parseInt(size), parseInt(savedFilter.length));
    //     }
    //   } else if (name == 'material') {
    //     this.selectedMaterial = [];
    //     this.filterByMaterial = [];
    //     if (material >= 0) {
    //       savedFilter.splice(parseInt(material), parseInt(savedFilter.length));
    //     }
    //   } else if (name == 'sort') {
    //     if (sort >= 0) {
    //       savedFilter.splice(parseInt(sort), parseInt(savedFilter.length));
    //     }
    //   }

    //   localStorage.setItem('fillters', JSON.stringify(savedFilter));
    //   this.fetchProdustQuery();
    //   this.clearAllOption();
    // },

    clearCheckBoxs(name) {
      try {
        const markedCheckbox = document.getElementsByName(name);
        for (const checkbox of markedCheckbox) {
          if (checkbox.checked) checkbox.checked = false;
        }
      } catch (e) {
        // ignore
      }

      let savedFilter = [];
      const savedItem = localStorage.getItem('fillters') || [];
      let category, size, material, color, sort;
      category = -1;
      size = -1;
      material = -1;
      color = -1;
      sort = -1;

      if (savedItem != '') {
        try {
          savedFilter = JSON.parse(savedItem);
        } catch {
          savedFilter = [];
        }

        savedFilter.map((e, i) => {
          if (Object.prototype.hasOwnProperty.call(e, 'Category')) {
            category = i;
          } else if (Object.prototype.hasOwnProperty.call(e, 'Color')) {
            color = i;
          } else if (Object.prototype.hasOwnProperty.call(e, 'Size')) {
            size = i;
          } else if (Object.prototype.hasOwnProperty.call(e, 'Material')) {
            material = i;
          } else if (Object.prototype.hasOwnProperty.call(e, 'sort')) {
            sort = i;
          }
        });
      }

      if (name == 'category') {
        this.selected = [];
        this.filterByCategory = [];
        if (category >= 0) {
          savedFilter.splice(parseInt(category), parseInt(savedFilter.length));
        }
      } else if (name == 'color') {
        this.selectedColor = [];
        this.filterByColor = [];
        if (color >= 0) {
          savedFilter.splice(parseInt(color), parseInt(savedFilter.length));
        }
      } else if (name == 'size') {
        this.selectedSize = [];
        this.filterBySize = [];
        if (size >= 0) {
          savedFilter.splice(parseInt(size), parseInt(savedFilter.length));
        }
      } else if (name == 'material') {
        this.selectedMaterial = [];
        this.filterByMaterial = [];
        if (material >= 0) {
          savedFilter.splice(parseInt(material), parseInt(savedFilter.length));
        }
      } else if (name == 'sort') {
        if (sort >= 0) {
          savedFilter.splice(parseInt(sort), parseInt(savedFilter.length));
        }
      }
      try {
        localStorage.setItem('fillters', JSON.stringify(savedFilter));
      } catch (e) {
        console.warn('localStorage not available:', e);
      }
      this.fetchProdustQuery();
      this.clearAllOption();
    },

    // clear option that selected in drop down under particular option
    // clearAllOption() {
    //   if (this.selected.length > 0) {
    //     this.filterProduct();
    //   } else if (this.selectedColor.length > 0) {
    //     this.filterProductByColor();
    //   } else if (this.selectedSize.length > 0) {
    //     this.filterProductBySize();
    //   } else if (this.selectedMaterial.length > 0) {
    //     this.filterProductByMaterial();
    //   } else {
    //     this.showClearAll = false;
    //     this.productList = this.fullproductList; //this.array_chunk(products, 20);
    //     const applyCta = document.querySelector('.apply_filter_cta');
    //     applyCta.setAttribute('disabled', '');
    //     const clearBtn = document.querySelector('.clear-modifier');
    //     clearBtn.setAttribute('disabled', '');
    //   }
    // },
    clearAllOption() {
      if (this.selected.length > 0) {
        this.filterProduct();
      } else if (this.selectedColor.length > 0) {
        this.filterProductByColor();
      } else if (this.selectedSize.length > 0) {
        this.filterProductBySize();
      } else if (this.selectedMaterial.length > 0) {
        this.filterProductByMaterial();
      } else {
        this.showClearAll = false;
        // productList/fullproductList old legacy vars – keep behavior as-is if they exist
        if (this.fullproductList) {
          this.productList = this.fullproductList;
        }
        const applyCta = document.querySelector('.apply_filter_cta');
        applyCta && applyCta.setAttribute('disabled', '');
        const clearBtn = this.safeQuery('.clear-modifier');
        clearBtn && clearBtn.setAttribute('disabled', '');
      }
    },
    /* set selected color checkbox value */
    // onCheckColor(event) {
    //   if (this.selectedColor && this.selectedColor.includes(event.target.value)) {
    //     this.selectedColor = this.selectedColor.filter(function (geeks) {
    //       return geeks != event.target.value;
    //     });
    //   } else {
    //     if (!this.selectedColor) this.selectedColor = [];
    //     this.selectedColor.push(event.target.value);
    //   }
    //   if (this.selectedColor.length > 0) {
    //     this.showClearAll = true;
    //   }
    //   setTimeout(() => {
    //     this.fetchProdustQuery();
    //   }, 300);

    //   // console.log(this.selectedColor);
    // },
    onCheckColor(event) {
      const val = event?.target?.value;

      if (!val) return;

      if (this.selectedColor && this.selectedColor.includes(val)) {
        this.selectedColor = this.selectedColor.filter((geeks) => geeks !== val);
      } else {
        if (!this.selectedColor) this.selectedColor = [];
        this.selectedColor.push(val);
      }
      if (this.selectedColor.length > 0) {
        this.showClearAll = true;
      }
      this.hasNextPage = false;
      this.currentPage = 1;

      setTimeout(() => this.fetchProdustQuery(), 50);

      // console.log(this.selectedColor);
    },
    /* set selected size checkbox value */
    // onCheckSize(event) {
    //   if (this.selectedSize && this.selectedSize.includes(event.target.value?.toLowerCase())) {
    //     this.selectedSize = this.selectedSize.filter(function (geeks) {
    //       return geeks != event.target.value?.toLowerCase();
    //     });
    //   } else {
    //     if (!this.selectedSize) this.selectedSize = [];
    //     this.selectedSize.push(event.target.value?.toLowerCase());
    //   }
    //   if (this.selectedSize.length > 0) {
    //     this.showClearAll = true;
    //   }
    //   setTimeout(() => {
    //     this.fetchProdustQuery();
    //   }, 300);

    //   // console.log(this.selectedSize);
    // },

    onCheckSize(event) {
      const rawVal = event?.target?.value;
      const val = rawVal?.toLowerCase();
      if (!val) return;

      if (this.selectedSize && this.selectedSize.includes(val)) {
        this.selectedSize = this.selectedSize.filter((geeks) => geeks !== val);
      } else {
        if (!this.selectedSize) this.selectedSize = [];
        this.selectedSize.push(val);
      }

      if (this.selectedSize.length > 0) {
        this.showClearAll = true;
      }

      this.hasNextPage = false;
      this.currentPage = 1;

      setTimeout(() => this.fetchProdustQuery(), 50);
    },

    /* set selected material checkbox value */
    // onCheckMaterial(event) {
    //   if (this.selectedMaterial && this.selectedMaterial.includes(event.target.value)) {
    //     this.selectedMaterial = this.selectedMaterial.filter(function (geeks) {
    //       return geeks != event.target.value;
    //     });
    //   } else {
    //     if (!this.selectedMaterial) this.selectedMaterial = [];
    //     this.selectedMaterial.push(event.target.value);
    //   }
    //   if (this.selectedMaterial.length > 0) {
    //     this.showClearAll = true;
    //   }
    //   setTimeout(() => {
    //     this.fetchProdustQuery();
    //   }, 300);

    //   // console.log(this.selectedMaterial);
    // },

    onCheckMaterial(event) {
      const val = event?.target?.value;
      if (!val) return;

      if (this.selectedMaterial && this.selectedMaterial.includes(val)) {
        this.selectedMaterial = this.selectedMaterial.filter((geeks) => geeks !== val);
      } else {
        if (!this.selectedMaterial) this.selectedMaterial = [];
        this.selectedMaterial.push(val);
      }
      if (this.selectedMaterial.length > 0) {
        this.showClearAll = true;
      }

      this.hasNextPage = false;
      this.currentPage = 1;

      setTimeout(() => this.fetchProdustQuery(), 50);
    },

    /* set selected category checkbox value */
    // onCheck(event) {
    //   if (this.selected && this.selected.includes(event.target.value)) {
    //     this.selected = this.selected.filter(function (geeks) {
    //       return geeks != event.target.value;
    //     });
    //   } else {
    //     if (!this.selected) this.selected = [];
    //     this.selected.push(event.target.value);
    //   }
    //   if (this.selected.length > 0) {
    //     this.showClearAll = true;
    //   }

    //   setTimeout(() => {
    //     this.fetchProdustQuery();
    //   }, 300);

    //   this.page_index = 0;
    // },

    onCheck(event) {
      const val = event?.target?.value;
      if (!val) return;

      if (this.selected && this.selected.includes(val)) {
        this.selected = this.selected.filter((geeks) => geeks !== val);
      } else {
        if (!this.selected) this.selected = [];
        this.selected.push(val);
      }

      if (this.selected.length > 0) {
        this.showClearAll = true;
      }

      this.hasNextPage = false;
      this.currentPage = 1;

      setTimeout(() => this.fetchProdustQuery(), 50);

      this.page_index = 0;
    },

    /* set selected sort checkbox value */
    // onCheckSort(event) {
    //   // Clear all sort variables first
    //   this.selectedSortPercent = [];
    //   this.selectedNewArrival = '';
    //   this.priceSort = '';

    //   if ('Recommended' === event.target.value) {
    //     // For recommended, restore original order via sortProduct
    //     this.sortProduct(event.target.value);
    //     // No need to refetch, sortProduct handles it
    //   } else if ('Discount' == event.target.value) {
    //     this.sortProduct(event.target.value);
    //     this.selectedSortPercent = [event.target.value];
    //     setTimeout(() => {
    //       this.fetchProdustQuery();
    //     }, 300);
    //   } else if ('Latest' == event.target.value) {
    //     this.selectedNewArrival = event.target.value;
    //     setTimeout(() => {
    //       this.fetchProdustQuery();
    //     }, 300);
    //   } else if (event.target.value === 'LowToHigh' || event.target.value === 'HighToLow') {
    //     this.priceSort = event.target.value;
    //     setTimeout(() => {
    //       this.fetchProdustQuery();
    //     }, 300);
    //   }
    // },

    onCheckSort(event) {
      const value = event?.target?.value;
      if (!value) return;

      // Clear all sort variables first
      this.selectedSortPercent = [];
      this.selectedNewArrival = '';
      this.priceSort = '';

      if (value === 'Recommended') {
        this.sortProduct(value);
      } else if (value === 'Discount') {
        this.sortProduct(value);
        this.selectedSortPercent = [value];
        setTimeout(() => {
          this.fetchProdustQuery();
        }, 300);
      } else if (value === 'Latest') {
        this.selectedNewArrival = value;
        setTimeout(() => {
          this.fetchProdustQuery();
        }, 300);
      } else if (value === 'LowToHigh' || value === 'HighToLow') {
        this.priceSort = value;
        setTimeout(() => {
          this.fetchProdustQuery();
        }, 300);
      }
    },

    /* Fill category dropdown from products data */

    // getCategoryDropDownList() {
    //   const products = this.roughData();
    //   const shopifyData = this.getShopifyData();
    //   const data = window.atob(shopifyData.category || '');
    //   const data2 = window.atob(shopifyData.category || '');

    //   const url = window.location.pathname.split('/');
    //   const lastSegment = url.pop() || url.pop();

    //   const category1 = JSON.parse(data2);
    //   const category2 = JSON.parse(data);
    //   let flag = false;

    //   category1.map((mapUrl) => {
    //     if (mapUrl.rules.handle == lastSegment) {
    //       flag = true;
    //     }
    //   });
    //   let cat;
    //   if (flag == false) {
    //     cat = category2;
    //   } else {
    //     cat = category1;
    //   }
    //   // cat = category2

    //   const array = [];
    //   const rol = [];

    //   let $pCpunt = 0;
    //   cat.map((cList, index) => {
    //     $pCpunt = 0;
    //     let flg = false;
    //     products.map((plist) => {
    //       if (plist.length === 6) {
    //         if (plist[3] && plist[3].includes(cList.rules.title)) {
    //           $pCpunt++;
    //         }
    //         if (plist[3] && plist[3].includes(cList.label)) {
    //           flg = true;
    //         }
    //       }
    //     });

    //     if (flg == false) return;
    //     // console.log($pCpunt);

    //     const obj = {
    //       id: index + 1,
    //       value: cList.label,
    //       text: cList.label,
    //       count: $pCpunt,
    //     };
    //     array.push(obj);
    //     rol.push(cList.rules);
    //   });

    //   const newarray = [array, rol];

    //   return newarray;
    // },

    getCategoryDropDownList() {
      const products = this.roughData();
      const shopifyData = this.getShopifyData();
      const raw = shopifyData.category || '[]';

      let data = '[]';
      let data2 = '[]';

      try {
        data = window.atob(raw);
        data2 = window.atob(raw);
      } catch (e) {
        console.error('Error decoding category:', e);
      }

      const url = window.location.pathname.split('/');
      const lastSegment = url.pop() || url.pop();

      let category1 = [];
      let category2 = [];
      try {
        category1 = JSON.parse(data2);
        category2 = JSON.parse(data);
      } catch (e) {
        console.error('Error parsing category JSON:', e);
      }

      let flag = false;

      category1.map((mapUrl) => {
        if (mapUrl?.rules?.handle === lastSegment) {
          flag = true;
        }
      });

      const cat = flag ? category1 : category2;

      const array = [];
      const rol = [];

      let pCount = 0;
      cat.map((cList, index) => {
        pCount = 0;
        let flg = false;
        products.map((plist) => {
          if (plist.length === 6) {
            if (plist[3] && plist[3].includes(cList.rules.title)) {
              pCount++;
            }
            if (plist[3] && plist[3].includes(cList.label)) {
              flg = true;
            }
          }
        });

        if (flg === false) return;

        const obj = {
          id: index + 1,
          value: cList.label,
          text: cList.label,
          count: pCount,
        };
        array.push(obj);
        rol.push(cList.rules);
      });

      return [array, rol];
    },
    /* End Fill category dropdown from products data */

    /* Fill color dropdown from products data */

    // getColorDropDownList() {
    //   const products = this.roughData();
    //   const shopifyData = this.getShopifyData();
    //   const array = [];
    //   const rol = [];
    //   const color = JSON.parse(window.atob(shopifyData.color || '[]'));

    //   color.map((cColor, index) => {
    //     let $pCpunt = 0;
    //     let flg = false;
    //     products.map((plist) => {
    //       if (plist.length === 6) {
    //         if (plist[3] && plist[3].includes(cColor.rules.title)) {
    //           $pCpunt++;
    //         }
    //         if (plist[3] && plist[3].includes(cColor.label)) {
    //           flg = true;
    //         }
    //       }
    //     });

    //     if (flg === false) return;

    //     const obj = {
    //       id: index + 1,
    //       value: cColor.label,
    //       text: cColor.label,
    //       count: $pCpunt,
    //     };
    //     array.push(obj);
    //     rol.push(cColor.rules);
    //   });
    //   return [array, rol];
    // },

    getColorDropDownList() {
      const products = this.roughData();
      const shopifyData = this.getShopifyData();
      const array = [];
      const rol = [];

      let color = [];
      try {
        color = JSON.parse(window.atob(shopifyData.color || '[]'));
      } catch (e) {
        console.error('Error parsing color JSON:', e);
        color = [];
      }

      color.map((cColor, index) => {
        let pCount = 0;
        let flg = false;
        products.map((plist) => {
          if (plist.length === 6) {
            if (plist[3] && plist[3].includes(cColor.rules.title)) {
              pCount++;
            }
            if (plist[3] && plist[3].includes(cColor.label)) {
              flg = true;
            }
          }
        });

        if (flg === false) return;

        const obj = {
          id: index + 1,
          value: cColor.label,
          text: cColor.label,
          count: pCount,
        };
        array.push(obj);
        rol.push(cColor.rules);
      });
      return [array, rol];
    },

    /* End Fill color dropdown from products data */

    /* Fill size dropdown from products data */
    // getSizeDropDownList() {
    //   const Products = this.roughData();
    //   const shopifyData = this.getShopifyData();
    //   const array = [];
    //   const size = JSON.parse(window.atob(shopifyData.size || '[]'));

    //   size.map((cSize, index) => {
    //     let $pCpunt = 0;
    //     let flg = false;

    //     for (const product in Products) {
    //       if (Products[product][0]['options'].indexOf('Size') !== -1) {
    //         const indexOF = Products[product][0]['options'].indexOf('Size');
    //         Products[product][0].variants.map((m_varint) => {
    //           if (
    //             m_varint[`option${parseInt(indexOF) + 1}`].toLowerCase() ===
    //             cSize.label.toLowerCase()
    //           ) {
    //             flg = true;
    //             $pCpunt++;
    //           }
    //         });
    //       }
    //     }

    //     if (flg == false) return;

    //     const obj = {
    //       id: index + 1,
    //       value: cSize.label,
    //       text: cSize.label,
    //       count: $pCpunt,
    //     };
    //     array.push(obj);
    //   });

    //   return array;
    // },

    getSizeDropDownList() {
      const Products = this.roughData();
      const shopifyData = this.getShopifyData();
      const array = [];

      let size = [];
      try {
        size = JSON.parse(window.atob(shopifyData.size || '[]'));
      } catch (e) {
        console.error('Error parsing size JSON:', e);
        size = [];
      }

      size.map((cSize, index) => {
        let pCount = 0;
        let flg = false;

        for (const product in Products) {
          if (Products[product][0]['options'].indexOf('Size') !== -1) {
            const indexOF = Products[product][0]['options'].indexOf('Size');
            Products[product][0].variants.map((m_varint) => {
              const opt = m_varint[`option${parseInt(indexOF) + 1}`];
              if (opt && opt.toLowerCase() === cSize.label.toLowerCase()) {
                flg = true;
                pCount++;
              }
            });
          }
        }

        if (flg === false) return;

        const obj = {
          id: index + 1,
          value: cSize.label,
          text: cSize.label,
          count: pCount,
        };
        array.push(obj);
      });

      return array;
    },
    /* End Fill size dropdown from products data */

    /* Fill material dropdown from products data */
    // getMaterialDropDownList() {
    //   const products = this.roughData();
    //   const shopifyData = this.getShopifyData();
    //   const array = [];
    //   const rol = [];
    //   const material = JSON.parse(window.atob(shopifyData.material || '[]'));
    //   material.map((cMaterial, index) => {
    //     let flg = false;
    //     let $pCpunt = 0;
    //     products.map((plist) => {
    //       if (plist.length === 6) {
    //         if (plist[3] && plist[3].includes(cMaterial.rules.title)) {
    //           $pCpunt++;
    //         }
    //         if (plist[3] && plist[3].includes(cMaterial.label)) {
    //           flg = true;
    //         }
    //       }
    //     });

    //     if (flg == false) return;

    //     const obj = {
    //       id: index + 1,
    //       value: cMaterial.label,
    //       text: cMaterial.label,
    //       count: $pCpunt,
    //     };
    //     array.push(obj);
    //     rol.push(cMaterial.rules);
    //   });
    //   return [array, rol];
    // },

    getMaterialDropDownList() {
      const products = this.roughData();
      const shopifyData = this.getShopifyData();
      const array = [];
      const rol = [];

      let material = [];
      try {
        material = JSON.parse(window.atob(shopifyData.material || '[]'));
      } catch (e) {
        console.error('Error parsing material JSON:', e);
        material = [];
      }

      material.map((cMaterial, index) => {
        let flg = false;
        let pCount = 0;
        products.map((plist) => {
          if (plist.length === 6) {
            if (plist[3] && plist[3].includes(cMaterial.rules.title)) {
              pCount++;
            }
            if (plist[3] && plist[3].includes(cMaterial.label)) {
              flg = true;
            }
          }
        });

        if (flg === false) return;

        const obj = {
          id: index + 1,
          value: cMaterial.label,
          text: cMaterial.label,
          count: pCount,
        };
        array.push(obj);
        rol.push(cMaterial.rules);
      });
      return [array, rol];
    },
    /* End Fill material dropdown from products data */

    /* set product in array based on selected category option */
    filterProduct() {
      // let array = [];
      this.filterByCategory = this.selected;
      // array = this.getUniqueRecord(this.selected, "category");

      // this.filterByCategory = [];
      // this.clearAllOption();
      this.page_index = 0;
    },

    /* set product in array based on selected color option */
    filterProductByColor() {
      //this.saveFilter("Color", this.selectedColor);
      this.page_index = 0;
    },

    /* set product in array based on selected size option */
    filterProductBySize() {
      //this.saveFilter("Size", this.selectedSize);
      // this.filterBySize = [];
      //     this.clearAllOption();
      this.page_index = 0;
    },

    /* set product in array based on selected material option */
    filterProductByMaterial() {
      //this.saveFilter("Material", this.selectedMaterial);
      //   this.filterByMaterial = [];
      //     this.clearAllOption();

      this.page_index = 0;
    },

    filterArrayToUniqueRecord(array, filterWithArray) {
      return filterWithArray.filter((el) => {
        return array.some((f) => {
          return f.id === el.id;
        });
      });
    },

    categoryRulesApplied(currentCollection) {
      const Categoriesrules = JSON.parse(JSON.stringify(this.getCategoryDropDownList()))[1];

      // check rules is empty
      if (Categoriesrules.length === 0) {
        return false;
      }

      Categoriesrules.map((colection) => {
        if (currentCollection === colection.title) {
          // console.log(i, Categoriesrules);
        } else {
          return false;
        }
      });

      return false;
    },

    fetchProdustQuery() {
      /********************************************************************/
      // 🛠️ Step 1: Defensive parsing — handle malformed or missing data
      /********************************************************************/
      let Products;
      try {
        // ✅ Use collectionListingData (which includes loaded pages) if available, otherwise use original
        const collectionData =
          this.collectionListingData || this.decodedShopifyData.collectionListing;

        // ✅ Validate encoded collection data
        if (!collectionData || collectionData.trim() === '') {
          console.warn('⚠️ Collection listing data is empty or missing');
          this.Products = [];
          this.ProductsRaw = [];
          return;
        }

        const productData = window.atob(collectionData);
        if (!productData || productData.trim() === '') {
          console.warn('⚠️ Decoded collection data is empty');
          this.Products = [];
          this.ProductsRaw = [];
          return;
        }

        // ✅ Parse decoded data safely
        Products = JSON.parse(productData);

        if (!Array.isArray(Products)) {
          console.warn('⚠️ Parsed collection data is not an array:', typeof Products);
          this.Products = [];
          this.ProductsRaw = [];
          return;
        }

        // ✅ Store original parsed data
        this.ProductsRaw = Products;
        this.diagnostics = [];
      } catch (err) {
        console.error('❌ Failed to parse collection listing:', err);
        this.ProductsRaw = [];
        this.diagnostics = [
          {
            index: 'parse',
            included: false,
            reasons: ['parse_error'],
            note: err?.message || String(err),
          },
        ];

        // 🔸 Log client-side error with fallback-safe syntax
        try {
          this.sendClientLog('error', {
            msg: 'Failed to parse collectionListing',
            error: err?.stack || err?.message || String(err),
            shopifyDataPreview: this.shopifyData?.collectionListing
              ? String(this.decodedShopifyData.collectionListing).slice(0, 200)
              : null,
          });
        } catch (e) {
          console.error('sendClientLog failed', e);
        }
        this.Products = [];
        return;
      }
      /*********************************************************/
      // 🧩 Step 2: Filter preparation
      /*********************************************************/
      const filterListing = [];
      const duplicateRecord = [];
      let percentCount = 0;

      const Categories = JSON.parse(JSON.stringify(this.selected));
      const Color = JSON.parse(JSON.stringify(this.selectedColor));
      const Size = JSON.parse(JSON.stringify(this.selectedSize));
      const Material = JSON.parse(JSON.stringify(this.selectedMaterial));

      if (
        Categories.length === 0 &&
        Color.length === 0 &&
        Size.length === 0 &&
        Material.length === 0
      ) {
        this.showClearAll = false;
      }

      const selectedSortPercent = JSON.parse(JSON.stringify(this.selectedSortPercent));
      /* eslint-disable no-unused-vars */
      // const ColorRules = JSON.parse(JSON.stringify(this.getColorDropDownList()))[1];
      // const MaterialRules = JSON.parse(JSON.stringify(this.getMaterialDropDownList()))[1];
      /* eslint-enable no-unused-vars */
      const Categoriesrules = JSON.parse(JSON.stringify(this.getCategoryDropDownList()))[1];

      /*********************************************************/
      // 🔹 Step 3: Store original Shopify collection order
      /*********************************************************/
      const originalSequence = Products.map((p, index) => ({
        handle: p?.[0]?.handle,
        index,
      }));

      Products.forEach((product, index) => {
        if (product && product[0]) {
          product._shopifyOriginalIndex = index;
        }
      });

      /*********************************************************/
      // 🔹 Step 4: Apply sorting
      /*********************************************************/
      if (this.priceSort === 'HighToLow') {
        Products.sort((a, b) => b[0].price - a[0].price);
      } else if (this.priceSort === 'LowToHigh') {
        Products.sort((a, b) => a[0].price - b[0].price);
      } else if (this.selectedNewArrival !== '') {
        Products.sort((a, b) => new Date(b[0].published_at) - new Date(a[0].published_at));
      } else if (selectedSortPercent.length > 0) {
        Products = Products.filter((p) => p[0].compare_at_price && p[0].compare_at_price !== 0);
        Products.sort((a, b) => {
          const ac = (100 * b[0].compare_at_price) / b[0].price;
          const bc = (100 * a[0].compare_at_price) / a[0].price;
          return ac - bc;
        });
      }

      /*********************************************************/
      // 🔹 Step 5: Product filtering logic
      /*********************************************************/
      for (const product in Products) {
        const diag = {
          index: product,
          included: false,
          reasons: [],
          note: '',
          handle: null,
          title: null,
        };

        if (!Products[product] || !Products[product][0]) {
          diag.reasons.push('missing_root_object');
          diag.note = 'Missing product root object';
          this.diagnostics.push(diag);
          continue;
        }

        const p = Products[product][0];
        const v = Products[product][1];
        const stock = Products[product][2];
        const collection = Products[product][3];
        const handle = p.handle;
        diag.handle = handle;
        diag.title = p.title;

        const originalIndex =
          Products[product]._shopifyOriginalIndex !== undefined
            ? Products[product]._shopifyOriginalIndex
            : parseInt(product);

        /*********************************************************/
        // 🔸 Category / Color / Size / Material filters
        /*********************************************************/

        // ✅ Category Filter
        if (Categories.length !== 0) {
          let catFlag = false;
          let catFlagRules = false;
          Categories.map((selectedCats) => {
            if (Array.isArray(collection) && collection.includes(selectedCats)) catFlag = true;
            Categoriesrules.map((catRules) => {
              if (selectedCats === catRules.title && catRules.rules) {
                catRules.rules.map((rule) => {
                  if (
                    rule.column === 'title' &&
                    rule.relation === 'contains' &&
                    p.title.includes(rule.condition)
                  ) {
                    catFlagRules = true;
                  }
                  if (
                    rule.column === 'title' &&
                    rule.relation === 'equals' &&
                    p.title === rule.condition
                  ) {
                    catFlagRules = true;
                  }
                });
              }
            });
          });
          if (!catFlag && !catFlagRules) {
            diag.reasons.push('category_mismatch');
            this.diagnostics.push(diag);
            continue;
          }
        }

        // ✅ Color Filter
        if (Color.length !== 0) {
          let colorFlag = false;
          const colorFlagRules = false;
          if (Array.isArray(p.options) && p.options.indexOf('Color') !== -1) {
            const colorIndex = p.options.indexOf('Color');
            p.variants.map((variant) => {
              Color.map((selectedColor) => {
                if (
                  variant[`option${colorIndex + 1}`] &&
                  variant[`option${colorIndex + 1}`].toLowerCase() === selectedColor.toLowerCase()
                ) {
                  colorFlag = true;
                }
              });
            });
          }
          if (!colorFlag) {
            Color.map((selectedColor) => {
              if (Array.isArray(collection) && collection.includes(selectedColor)) colorFlag = true;
            });
          }
          if (!colorFlag && !colorFlagRules) {
            diag.reasons.push('color_mismatch');
            this.diagnostics.push(diag);
            continue;
          }
        }

        // ✅ Material Filter
        // if (Material.length !== 0) {
        //   let materialFlag = false;
        //   if (Array.isArray(p.options) && p.options.indexOf('Material') !== -1) {
        //     const matIndex = p.options.indexOf('Material');
        //     p.variants.map((variant) => {
        //       Material.map((selectedMaterial) => {
        //         if (
        //           variant[`option${matIndex + 1}`] &&
        //           variant[`option${matIndex + 1}`].toLowerCase() === selectedMaterial.toLowerCase()
        //         ) {
        //           materialFlag = true;
        //         }
        //       });
        //     });
        //   }
        //   if (!materialFlag) {
        //     Material.map((selectedMaterial) => {
        //       if (Array.isArray(collection) && collection.includes(selectedMaterial))
        //         materialFlag = true;
        //     });
        //   }
        //   if (!materialFlag) {
        //     diag.reasons.push('material_mismatch');
        //     this.diagnostics.push(diag);
        //     continue;
        //   }
        // }

        if (Material.length !== 0) {
          let materialFlag = false;

          if (Array.isArray(p.options) && p.options.indexOf('Material') !== -1) {
            const matIndex = p.options.indexOf('Material');

            p.variants.forEach((variant) => {
              Material.forEach((selectedMaterial) => {
                const optVal = variant[`option${matIndex + 1}`];
                if (optVal && optVal.toLowerCase().includes(selectedMaterial.toLowerCase())) {
                  materialFlag = true;
                }
              });
            });
          }

          if (!materialFlag) {
            diag.reasons.push('material_mismatch');
            this.diagnostics.push(diag);
            continue;
          }
        }

        // ✅ Size Filter
        if (Size.length !== 0) {
          let sizeFlag = false;
          if (Array.isArray(p.options) && p.options.indexOf('Size') !== -1) {
            const sizeIndex = p.options.indexOf('Size');
            p.variants.map((variant) => {
              if (Size.includes(variant[`option${sizeIndex + 1}`]?.toLowerCase())) {
                sizeFlag = true;
              }
            });
          }
          if (!sizeFlag) {
            diag.reasons.push('size_mismatch');
            this.diagnostics.push(diag);
            continue;
          }
        }

        // ✅ Track discount percentage
        if (p.compare_at_price > p.price) {
          percentCount++;
        }

        /*********************************************************/
        // 🔹 Step 6: Bind variants or single product
        /*********************************************************/
        let links = '';
        for (const varints in v) {
          if (varints === 'testing_product_variants') {
            links = v['testing_product_variants'];
          }
        }

        const bindInPair = [];
        let flag = false;

        if (typeof links === 'string' && links.includes('/')) {
          links = links.split(' ');
          links.forEach((lnk) => {
            if (lnk.replace('/products/', '') !== handle) {
              bindInPair.push(lnk.replace('/products/', ''));
              duplicateRecord.push(lnk.replace('/products/', ''));
            }
          });
        } else {
          flag = true;
        }

        const productType = {};
        if (bindInPair.length > 0) {
          const swatch = this.getSwatch(v, Products[product][4], Products[product][5], Products);
          const collectPairProducts = [];
          let variableActiveIndex = 0;

          for (const swatchPl in swatch) {
            const Phandle2 = swatch[swatchPl].link;
            for (const childPair in Products) {
              if (Products[childPair][0].handle === Phandle2.replace('/products/', '')) {
                if (handle === Products[childPair][0].handle) variableActiveIndex = swatchPl;

                Products[childPair][0].variants = this.appendStock(
                  Products[childPair][0].variants,
                  Products[childPair][2]
                );

                Products[childPair][0]['collection'] = Products[childPair][3];
                Products[childPair][0]['swatchesImage'] = Products[childPair][4];
                collectPairProducts.push(Products[childPair][0]);
              }
            }
          }

          if (collectPairProducts.length > 0) {
            productType['variable'] = collectPairProducts;
            productType['swatches'] = swatch;
            productType['active'] = variableActiveIndex;
            productType['_originalIndex'] = originalIndex;
            filterListing.push(productType);
          }
        } else if (flag) {
          p.variants = this.appendStock(p.variants, stock);
          p['collection'] = collection;
          productType['single'] = p;
          productType['_originalIndex'] = originalIndex;
          filterListing.push(productType);
        }
      }

      /*********************************************************/
      // 🔹 Step 7: Restore original order (if no sort)
      /*********************************************************/
      filterListing.forEach((prod) => {
        const handle =
          prod.single?.handle || (prod.variable && prod.variable[prod.active]?.handle) || null;
        if (handle) {
          const orig = originalSequence.find((o) => o.handle === handle);
          if (orig) prod._originalIndex = orig.index;
        }
      });

      if (percentCount === 0) this.isPercentDiscount = false;
      else this.isPercentDiscount = true;

      if (
        this.priceSort === '' &&
        this.selectedNewArrival === '' &&
        selectedSortPercent.length === 0
      ) {
        filterListing.sort((a, b) => a._originalIndex - b._originalIndex);
        console.log('✅ Products sorted by Shopify original order');
      }

      /*********************************************************/
      // 🔹 Step 8: Final assignment
      /*********************************************************/
      this.AllProducts = [...filterListing];
      this.Products = [...filterListing];

      if (this.setDefaultProduct.length === 0) {
        this.setDefaultProduct = JSON.parse(JSON.stringify(filterListing));
        console.log('🗂️ Original product order stored for Recommended sorting');
      }

      console.log('🎯 Final Products:', this.Products.length);
    },

    /**
     * ✅ Unified Client-side Logger
     * - Always logs to console.
     * - Optionally sends to remote endpoint (`window.__CLIENT_LOGGING.url`).
     * - Rate-limits identical messages per session using sessionStorage.
     * - Safe for Vue 2 (no default params in signature).
     */
    sendClientLog(level, payload) {
      // 👇 fallback defaults for compatibility
      level = level || 'log';
      payload = payload || {};

      try {
        const now = new Date().toISOString();
        const page =
          typeof window !== 'undefined' && window.location && window.location.pathname
            ? window.location.pathname
            : '';

        const body = {
          level,
          page,
          time: now,
          payload,
          userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : null,
        };

        // ✅ Console output based on level
        if (level === 'error') console.error('[ClientLog]', body);
        else if (level === 'warn') console.warn('[ClientLog]', body);
        else console.log('[ClientLog]', body);

        // ✅ Rate-limit identical messages (once per session)
        let key =
          'client_log:' +
          (payload && payload.msg ? payload.msg : JSON.stringify(payload)).slice(0, 200);
        try {
          key = 'client_log:' + btoa(unescape(encodeURIComponent(key))).slice(0, 80);
        } catch (e) {
          // ignore encoding issues
        }

        if (typeof sessionStorage !== 'undefined') {
          if (sessionStorage.getItem(key)) return; // already sent in this session
          sessionStorage.setItem(key, now);
        }

        // ✅ Optional remote logging (non-blocking)
        const cfg =
          typeof window !== 'undefined' && window.__CLIENT_LOGGING ? window.__CLIENT_LOGGING : null;

        if (cfg && cfg.url) {
          const payloadToSend = JSON.stringify(body);
          if (typeof navigator !== 'undefined' && navigator.sendBeacon) {
            try {
              navigator.sendBeacon(
                cfg.url,
                new Blob([payloadToSend], { type: 'application/json' })
              );
            } catch (e) {
              fetch(cfg.url, {
                method: 'POST',
                body: payloadToSend,
                headers: { 'Content-Type': 'application/json' },
              }).catch(() => {});
            }
          } else {
            fetch(cfg.url, {
              method: 'POST',
              body: payloadToSend,
              headers: { 'Content-Type': 'application/json' },
            }).catch(() => {});
          }
        }
      } catch (err) {
        console.error('Client log error:', err);
      }
    },

    // fillter dropdownlist

    intersect(a, b) {
      return a.filter(Set.prototype.has, new Set(b));
    },

    filterDropdow($productList) {
      // global variables
      const ddTestCategory = JSON.parse(JSON.stringify(this.ddTestCategory));
      const ddTestColor = JSON.parse(JSON.stringify(this.ddTestColor));
      // var ddTestSize = JSON.parse(JSON.stringify(this.ddTestSize));
      // var ddTestMaterial = JSON.parse(JSON.stringify(this.ddTestMaterial));

      const Categories = JSON.parse(JSON.stringify(this.selected));
      const Color = JSON.parse(JSON.stringify(this.selectedColor));
      const Size = JSON.parse(JSON.stringify(this.selectedSize));
      const Material = JSON.parse(JSON.stringify(this.selectedMaterial));

      const AllFillters = [];

      if (Categories.length !== 0) Categories.map((c) => AllFillters.push(c));
      if (Color.length !== 0) Color.map((cl) => AllFillters.push(cl));
      if (Size.length !== 0) Size.map((s) => AllFillters.push(s));
      if (Material.length !== 0) Material.map((m) => AllFillters.push(m));

      if (
        Categories.length !== 0 ||
        Color.length !== 0 ||
        Size.length !== 0 ||
        Material.length !== 0
      ) {
        // category filter

        /******************************************************************************/
        ///////////////  category filter
        /******************************************************************************/

        ddTestCategory[0].map((catList, index) => {
          let cat_count = 0;
          for (const plist of $productList) {
            if (Object.prototype.hasOwnProperty.call(plist, 'variable')) {
              let checkOnce = false;
              plist.variable.map((c_list) => {
                if (
                  c_list.collection &&
                  c_list.collection.includes(catList.value) &&
                  this.intersect(AllFillters, c_list.collection).length > 0 &&
                  checkOnce === false
                ) {
                  cat_count++;
                  checkOnce = true;
                }
              });
            } else if (Object.prototype.hasOwnProperty.call(plist, 'single')) {
              if (
                plist.single.collection &&
                plist.single.collection.includes(catList.value) &&
                this.intersect(AllFillters, plist.single.collection).length > 0
              ) {
                cat_count++;
              }
            }
          }

          ddTestCategory[0][index].count = cat_count;
        });

        this.ddTestCategory = ddTestCategory;

        /******************************************************************************/
        ///////////////  Color Filter
        /******************************************************************************/

        ddTestColor[0].map((colList, index) => {
          let color_count = 0;
          for (const p_color_list of $productList) {
            if (Object.prototype.hasOwnProperty.call(p_color_list, 'variable')) {
              let colorCheckOnce = false;
              p_color_list.variable.map((c_color_list) => {
                if (
                  c_color_list.collection &&
                  c_color_list.collection.includes(colList.value) &&
                  this.intersect(AllFillters, colList.collection).length > 0 &&
                  colorCheckOnce === false
                ) {
                  color_count++;
                  colorCheckOnce = true;
                }
              });
            } else if (Object.prototype.hasOwnProperty.call(p_color_list, 'single')) {
              if (
                p_color_list.single.collection &&
                p_color_list.single.collection.includes(colList.value) &&
                this.intersect(AllFillters, p_color_list.single.collection).length > 0
              ) {
                color_count++;
              }
            }
          }

          ddTestColor[0][index].count = color_count;
        });

        this.ddTestColor = ddTestColor;

        // console.log(ddTestCategory)
        // console.log(ddTestColor)
        // console.log(ddTestSize)
        // console.log(ddTestMaterial)
        // console.log($productList)
      }
    },

    shuffle(array) {
      let currentIndex = array.length,
        randomIndex;

      // While there remain elements to shuffle.
      while (currentIndex != 0) {
        // Pick a remaining element.
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;

        // And swap it with the current element.
        [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
      }

      return array;
    },

    appendStock(variants, stocks) {
      const newVariants = [];
      variants.map((appendStock) => {
        const V_id = appendStock.id;
        for (const stok in stocks) {
          if (stok == V_id) {
            const newVar = appendStock;
            newVar.inStock = stocks[stok];
            newVariants.push(newVar);
          }
        }
      });
      return newVariants;
    },

    // getSalesProduct:function(){
    //   this.AllProducts.map(()=>{

    //   })
    // },

    checkStatus(prodcut) {
      if (Object.prototype.hasOwnProperty.call(prodcut, 'variable')) {
        return prodcut.variable[0] === undefined ? false : true;
      }
      if (Object.prototype.hasOwnProperty.call(prodcut, 'single')) {
        return prodcut.single === undefined ? false : true;
      }
    },

    /* sort product based on price low to high and vice-verse */
    sortProduct(obj) {
      // var newArrivalCount = 0;
      // var product = [];
      let percentCount = 0;

      let AllProducts = JSON.parse(JSON.stringify(this.AllProducts));
      // console.log(AllProducts, "AllProducts");

      if (JSON.parse(JSON.stringify(this.setDefaultProduct)).length === 0) {
        this.setDefaultProduct = AllProducts;
      } else {
        AllProducts = JSON.parse(JSON.stringify(this.setDefaultProduct));
      }

      // Restore original collection order for "Recommended"
      if (obj == 'Recommended') {
        const restoredProducts = JSON.parse(JSON.stringify(this.setDefaultProduct));
        // Ensure they are sorted by original index
        restoredProducts.sort((a, b) => {
          const indexA = a._originalIndex !== undefined ? a._originalIndex : 999999;
          const indexB = b._originalIndex !== undefined ? b._originalIndex : 999999;
          return indexA - indexB;
        });
        this.Products = restoredProducts;
        this.AllProducts = restoredProducts;
        console.log('Restored original collection order');

        // Print product sequence after sorting
        console.log('===== PRODUCT SEQUENCE (AFTER RECOMMENDED SORT) =====');
        this.Products.forEach((product, index) => {
          let title = 'Unknown';
          let originalIdx = 'N/A';

          if (product.variable && product.variable.length > 0 && product.variable[product.active]) {
            title = product.variable[product.active].title;
          } else if (product.single) {
            title = product.single.title;
          }

          if (product._originalIndex !== undefined) {
            originalIdx = product._originalIndex;
          }

          console.log(`#${index + 1} | Original Index: ${originalIdx} | ${title}`);
        });
        console.log('===== END PRODUCT SEQUENCE =====');

        return;
      }

      if (obj == 'Latestqwqw') {
        //
      }

      // var counter = 0;

      if (obj == 'Discount') {
        const sortfilter = AllProducts.sort(function (a) {
          if (Object.prototype.hasOwnProperty.call(a, 'variable')) {
            if (a.variable.length !== 0) {
              if (a.variable[0].compare_at_price > a.variable[0].price) {
                percentCount++;
              }
              if (a.variable[0].compare_at_price > a.variable[0].price) {
                return;
              }
            }
          }
          if (Object.prototype.hasOwnProperty.call(a, 'single')) {
            if (a.single.compare_at_price > a.single.price) {
              percentCount++;
            }
            if (a.single.compare_at_price > a.single.price) {
              return;
            }
          }
        });

        this.Products = [...sortfilter]; // Load all sorted products
        this.AllProducts = [...sortfilter];
      }

      if (percentCount == 0) {
        this.isPercentDiscount = false;
      } else {
        this.isPercentDiscount = true;
      }
    },

    randomIntFromInterval(min, max) {
      // min and max included
      return Math.floor(Math.random() * (max - min + 1) + min);
    },

    // async addToCard(event) {
    //   // document.querySelector('.bg_layer_removecart').classList.add('active');

    //   event.target.closest('.card').classList.add('active');
    //   let product;
    //   if (event.target.tagName === 'SPAN') {
    //     product = event.target.parentNode;
    //   } else {
    //     product = event.target;
    //   }
    //   const variant = product.getAttribute('variantid');
    //   const dynamic = new ShopifyAPI();

    //   const item = {
    //     id: variant,
    //     qty: 1,
    //   };
    //   await dynamic.addItem(item);
    //   event.target.closest('.card').classList.remove('active');
    // },

    async addToCard(event) {
      const card = event.target.closest('.card');
      card && card.classList.add('active');

      let product;
      if (event.target.tagName === 'SPAN') {
        product = event.target.parentNode;
      } else {
        product = event.target;
      }
      const variant = product.getAttribute('variantid');
      const dynamic = new ShopifyAPI();

      const item = {
        id: variant,
        qty: 1,
      };
      await dynamic.addItem(item);
      card && card.classList.remove('active');
    },

    /**
     * Load more products via AJAX pagination
     */
    async loadMoreProducts() {
      if (this.isLoadingMore || !this.hasNextPage) {
        return;
      }

      this.isLoadingMore = true;
      const nextPage = this.currentPage + 1;

      try {
        // Build the URL for next page
        const shopifyData = this.getShopifyData();

        // Get collection handle from shopifyData or extract from URL as fallback
        let collectionHandle = shopifyData.collectionHandle;

        if (!collectionHandle) {
          // Fallback: Extract from current URL
          const urlPath = window.location.pathname;
          const match = urlPath.match(/\/collections\/([^/]+)/);
          if (match && match[1]) {
            collectionHandle = match[1];
          } else {
            console.error('Collection handle not found');
            this.hasNextPage = false;
            return;
          }
        }

        const url = `/collections/${collectionHandle}?page=${nextPage}`;

        // Fetch next page HTML
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error('Failed to load more products');
        }

        const html = await response.text();

        // Parse the HTML to extract product data
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const collectionElement = doc.querySelector('render-collection-all-page');

        if (collectionElement) {
          // Extract the new shopify-data-encoded attribute
          const encodedData = collectionElement.getAttribute('shopify-data-encoded');

          if (encodedData) {
            try {
              // Decode the base64 encoded JSON
              const decodedJson = window.atob(encodedData);
              const nextPageData = JSON.parse(decodedJson);

              // Extract collection listing from the decoded data
              const newProductsEncoded = nextPageData.collectionListing;

              if (newProductsEncoded) {
                const newProductsJson = window.atob(newProductsEncoded);
                const newProducts = JSON.parse(newProductsJson);

                console.log(`📦 New products fetched:`, newProducts.length);

                if (newProducts && newProducts.length > 0) {
                  // Store the raw products from this page
                  const currentRawProducts = this.roughData();
                  console.log(`📋 Current products:`, currentRawProducts.length);

                  // Combine old and new products
                  const combinedProducts = [...currentRawProducts, ...newProducts];
                  console.log(`🔗 Combined products:`, combinedProducts.length);

                  // Update the local copy of collection listing data (not the prop)
                  const combinedEncoded = window.btoa(JSON.stringify(combinedProducts));
                  this.collectionListingData = combinedEncoded;

                  // Store Products count before fetchProdustQuery
                  const beforeCount = this.Products.length;

                  // Re-run fetchProdustQuery to process all products
                  this.fetchProdustQuery();

                  // Check Products count after fetchProdustQuery
                  const afterCount = this.Products.length;
                  console.log(`🎯 Products display: Before=${beforeCount}, After=${afterCount}`);

                  // Update pagination state
                  this.currentPage = nextPage;
                  this.hasNextPage = nextPageData.hasNextPage || false;

                  console.log(`✅ Loaded page ${nextPage}, hasNextPage: ${this.hasNextPage}`);
                } else {
                  console.log('❌ No new products found');
                  this.hasNextPage = false;
                }
              }
            } catch (e) {
              console.error('Error parsing next page data:', e);
              this.hasNextPage = false;
            }
          }
        }
      } catch (error) {
        console.error('Error loading more products:', error);
        alert('Failed to load more products. Please try again.');
      } finally {
        this.isLoadingMore = false;
      }
    },

    /**
     *  getSwatch filter the json for each product also verify product has variation
     */
    getSwatch(metaFields, products, status, Products) {
      let links = '';
      let swatchs = '';
      const swatchLIST = [];

      for (const meta in metaFields) {
        const key = meta;

        if (key == 'testing_product_variants') {
          links = metaFields[meta].split(' ');
        }
        if (key == 'testing_product_swatchs') {
          swatchs = metaFields[meta].split(' ');
        }
      }

      // console.log(assets.assets)

      // collection variation if exist
      if (links.length !== 0 && swatchs.length !== 0) {
        //  conbine to link and swatchs

        for (const img in swatchs) {
          const imgLoop = img;
          for (const link in links) {
            if (link == imgLoop) {
              const repeatEl = {};
              // console.log(products, " === ")
              repeatEl.img = swatchs[imgLoop];
              repeatEl.status = '';
              repeatEl.url = products.filter((em) =>
                Object.keys(em)[0] === swatchs[imgLoop] ? Object.values(em)[0] : ''
              );
              repeatEl.link = links[link];
              swatchLIST.push(repeatEl);
            } else {
              continue;
            }
          }
        }
      }

      // activeHandle

      if (swatchLIST.length !== 0) {
        // var match = 1;

        const swatchList = swatchLIST.filter((list) => {
          const prestentList = list.link.split('/products/');

          for (const plist in Products) {
            if (Products[plist][0].handle === prestentList[1]) {
              return list;
            }
          }
        });

        return swatchList;
      }

      return false;

      // /**
      //  *  if nothing variation found above loop then return false (It's mean's product have no variation)
      // */
      // return false;
    },
    // selectVariation: (event) => {
    //   /**
    //    * targeted element id
    //    */
    //   const target = event.target;

    //   const grid =
    //     target.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode;

    //   const children = target.parentNode.parentNode.parentNode.children;

    //   for (let i = 0; i < children.length; i++) {
    //     children[i].setAttribute('activeindex', 'false');
    //   }

    //   // add active call to current active element
    //   // target.classList.add("active");
    //   target.parentNode.parentNode.setAttribute('activeindex', 'true');

    //   // get active index

    //   const index = target.parentNode.parentNode.getAttribute('index');

    //   // currentActiveIndex = index;

    //   const productsData = JSON.parse(
    //     target.parentNode.parentNode.parentNode.parentNode.getAttribute('main-key')
    //   );

    //   // active product
    //   const activeProduct = productsData.variable[index];

    //   // update product data

    //   // change title

    //   grid.querySelector('.product_title').innerHTML = activeProduct.title;

    //   let priceHtml = `<span class="tmb_product_price">`;

    //   if (activeProduct.price && activeProduct.compare_at_price) {
    //     priceHtml += `
    //   <span class="tmb_original_price">
    //     <del>${currencyJson[window?.Shopify?.currency?.active]?.symbol_native}${activeProduct.compare_at_price / 100}</del>
    //   </span>
    //   <span class="tmb_discounted">
    //     ${currencyJson[window?.Shopify?.currency?.active]?.symbol_native}${(activeProduct.price / 100).toFixed(2)}
    //   </span>
    //   <span class="discount-percentage">
    //     ${Math.round(((activeProduct.compare_at_price - activeProduct.price) / activeProduct.compare_at_price) * 100)}% off
    //   </span>`;
    //   } else {
    //     priceHtml += `
    // <span>
    //   ${currencyJson[window?.Shopify?.currency?.active]?.symbol_native}${activeProduct.price / 100}
    // </span>`;
    //   }

    //   priceHtml += `</span>`;

    //   grid.querySelector('.product_price').innerHTML = priceHtml;

    //   /// update link of the grid
    //   grid.getElementsByTagName('a')[0].setAttribute('href', '/products/' + activeProduct.handle);

    //   // console.log(activeProduct);
    //   // chnage images of the grid
    //   grid
    //     .querySelector('img.normal')
    //     .setAttribute(
    //       'src',
    //       activeProduct.featured_image == null
    //         ? 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png'
    //         : activeProduct.featured_image
    //     );

    //   grid
    //     .querySelector('img.hoverImg')
    //     .setAttribute(
    //       'src',
    //       activeProduct.images.length > 2
    //         ? activeProduct.images[1]
    //         : 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png'
    //     );

    //   // chnage quick button content
    //   // console.log(activeProduct)

    //   grid.querySelector('button').setAttribute('variantid', activeProduct.variants[0].id);

    //   if (activeProduct.variants[0].inStock == 0) {
    //     grid.querySelector('button').classList.add('quickAdd_deactive');
    //   } else {
    //     grid.querySelector('button').classList.remove('quickAdd_deactive');
    //   }

    //   // check how many product are left in product inventory

    //   if (activeProduct.variants[0].inStock == 0) {
    //     grid.querySelector('.item_left').classList.add('item_left_active');
    //     grid.querySelector('.item_left').innerHTML = 'SOLD OUT';
    //   } else if (activeProduct.totalInventory < 5) {
    //     grid.querySelector('.item_left').classList.add('item_left_active');
    //     grid.querySelector('.item_left').innerHTML =
    //       'Only ' + activeProduct.variants[0].inStock + ' Left';
    //   } else {
    //     grid.querySelector('.item_left').classList.remove('item_left_active');
    //   }
    // },

    selectVariation: (event) => {
      console.log('selectVariation called');
      const target = event.target;
      if (!target) return;

      const grid =
        target.parentNode &&
        target.parentNode.parentNode &&
        target.parentNode.parentNode.parentNode &&
        target.parentNode.parentNode.parentNode.parentNode &&
        target.parentNode.parentNode.parentNode.parentNode.parentNode &&
        target.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode &&
        target.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode;

      if (!grid) return;

      const children = target.parentNode.parentNode.parentNode.children;

      for (let i = 0; i < children.length; i++) {
        children[i].setAttribute('activeindex', 'false');
      }

      target.parentNode.parentNode.setAttribute('activeindex', 'true');

      const index = target.parentNode.parentNode.getAttribute('index');

      const productsDataRaw =
        target.parentNode.parentNode.parentNode.parentNode.getAttribute('main-key');
      if (!productsDataRaw) return;

      const productsData = JSON.parse(productsDataRaw);

      const activeProduct = productsData.variable[index];

      const titleEl = grid.querySelector('.product_title');
      if (titleEl) titleEl.innerHTML = activeProduct.title;

      let priceHtml = `<span class="tmb_product_price">`;

      if (activeProduct.price && activeProduct.compare_at_price) {
        priceHtml += `
    <span class="tmb_original_price">
      <del>
        ${currencyJson[window?.Shopify?.currency?.active]?.symbol_native} ${(
          activeProduct.compare_at_price / 100
        ).toLocaleString(undefined, { minimumFractionDigits: 2 })}
      </del>
    </span>
    <span class="tmb_discounted">
      ${currencyJson[window?.Shopify?.currency?.active]?.symbol_native} ${(
        activeProduct.price / 100
      ).toLocaleString(undefined, { minimumFractionDigits: 2 })}
    </span>
    <span class="discount-percentage">
      ${Math.round(
        ((activeProduct.compare_at_price - activeProduct.price) / activeProduct.compare_at_price) *
          100
      )}% off
    </span>`;
      } else {
        priceHtml += `
    <span>
      ${currencyJson[window?.Shopify?.currency?.active]?.symbol_native} ${(
        activeProduct.price / 100
      ).toLocaleString(undefined, { minimumFractionDigits: 2 })}
    </span>`;
      }

      priceHtml += `</span>`;

      const priceEl = grid.querySelector('.product_price');
      if (priceEl) priceEl.innerHTML = priceHtml;

      const mainLink = grid.getElementsByTagName('a')[0];
      if (mainLink) {
        mainLink.setAttribute('href', '/products/' + activeProduct.handle);
      }

      const normalImg = grid.querySelector('img.normal');
      if (normalImg) {
        normalImg.setAttribute(
          'src',
          activeProduct.featured_image == null
            ? 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png'
            : activeProduct.featured_image
        );
      }

      const hoverImg = grid.querySelector('img.hoverImg');
      if (hoverImg) {
        hoverImg.setAttribute(
          'src',
          activeProduct.images.length > 2
            ? activeProduct.images[1]
            : 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png'
        );
      }

      const btn = grid.querySelector('button');
      if (btn) {
        btn.setAttribute('variantid', activeProduct.variants[0].id);
        if (activeProduct.variants[0].inStock == 0) {
          btn.classList.add('quickAdd_deactive');
        } else {
          btn.classList.remove('quickAdd_deactive');
        }
      }

      const itemLeft = grid.querySelector('.item_left');
      if (!itemLeft) return;

      if (activeProduct.variants[0].inStock == 0) {
        itemLeft.classList.add('item_left_active');
        itemLeft.innerHTML = 'SOLD OUT';
      } else if (activeProduct.totalInventory < 5) {
        itemLeft.classList.add('item_left_active');
        itemLeft.innerHTML = 'Only ' + activeProduct.variants[0].inStock + ' Left';
      } else {
        itemLeft.classList.remove('item_left_active');
      }
    },
    /**
     * get theme upload assets list
     */

    getThemeAssets(image, object) {
      object = JSON.parse(JSON.stringify(object));
      let src = '';

      object.map((img) => {
        if (Object.prototype.hasOwnProperty.call(img, image)) {
          // var setOnce = false;
          // console.log(image, "=========", img[image]);
          // if(img[image].split('=')[1].length > 15 && setOnce == false)
          src = img[image];
          // setOnce = true;
        }
      });
      return src;
    },

    toggleContent() {
      this.showFullContent = !this.showFullContent;
      this.updateFooterParagraphVisibility();
    },
    checkFooterContent() {
      const paragraphs = Array.from(this.$refs.footerDescription?.querySelectorAll('p') || []);
      const nonEmptyParagraphs = paragraphs.filter((paragraph) => paragraph.textContent.trim());
      this.shouldTruncate = nonEmptyParagraphs.length > 1;
      this.showFullContent = false;

      this.updateFooterParagraphVisibility();
    },
    updateFooterParagraphVisibility() {
      const paragraphs = Array.from(this.$refs.footerDescription?.querySelectorAll('p') || []);
      const firstNonEmptyParagraph = paragraphs.find((paragraph) => paragraph.textContent.trim());

      paragraphs.forEach((paragraph) => {
        const shouldHide =
          this.shouldTruncate && !this.showFullContent && paragraph !== firstNonEmptyParagraph;
        paragraph.style.display = shouldHide ? 'none' : '';
      });
    },
  },
};
</script>

<style>
.footer_banner_description li {
  list-style: revert !important;
  font-family: 'adobe-caslon-pro', serif;
}

.add_remove button {
  cursor: pointer;
  width: 10px;
  height: 10px;
}

.color_swatches .swiper-wrapper .swiper-slide {
  width: 20px !important;
  display: block;
}

.color_swatches .swiper-wrapper .swiper-slide span {
  display: block;
  line-height: 0;
}

.color_swatches .swiper-button-next {
  right: 0;
}

.color_swatches .swiper-button-prev {
  left: 0;
}

/* .color_swatches .swiper-button-next {
  right: 0;
  height: 9px;
  width: 17px;
  transform: translateY(-50%) rotate(-90deg);
  margin-top: 0;
}
.color_swatches .swiper-button-prev {
  transform: translateY(-50%) rotate(90deg);
  margin-top: 0;
  left: 0;
  height: 9px;
  width: 17px;
} */
/* .color_swatches .swiper-button-prev:after,
.color_swatches .modify-slider .product_item .swiper-button-next::after-next:after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  line-height: 0;
  background-image: url('https://cdn.shopify.com/s/files/1/1000/3130/files/down-arrow-icon.svg?v=1667568894');
  background-repeat: no-repeat!important;
  background-position: center;
  background-size: contain;
  height: 100%;
  width: 100%;
} */

/* .color_swatches .swiper-button-prev:after {
  background-image: url('https://cdn.shopify.com/s/files/1/1000/3130/files/down-arrow-icon.svg?v=1667568894');
  transform: translate(0%, -50%);
  left: 0;
} */
/* .color_swatches .swiper-button-next:after {
  transform: translate(0%, -50%);
  right: 0;
  left: auto;
} */

.color_swatches .swiper-button-next,
.color_swatches .swiper-button-prev {
  height: 20px;
  width: 20px;
  border-radius: 0;
}

.color_swatches.tmbSlider .swiper-button-next {
  display: block !important;
}

.color_swatches .swiper-button-disabled {
  transition: 0.3s;
  visibility: hidden;
}

/* .color_swatches .swiper-button-lock {
  display: block;
} */
.color_swatches .swiper,
.color_swatches .swiper-wrapper {
  position: static;
}

/* .grid_inner.product-containers > div{
  padding-left: 6px;
}
.grid_inner.product-containers > div:first-child{
  padding-left: 0px;
} */
</style>

<style scoped>
.swatchesHide[status='false'] {
  display: none !important;
}

/* Collection Banner Css Code */

/* Original Collection Banner CSS (commented out) */
/*
.collaction_banner {
  position: relative;
}

.collaction_banner img {
  width: 100%;
  height: 330px;
  object-fit: cover;
  object-position: center;
}

.isPercentShow {
  display: none;
}

.collaction_banner .banner_heading {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  padding: 0 20px;
  transform: translate(-50%, -50%);
  font-weight: 700;
  text-align: center;
  font-size: 49px;
  color: #ffffff;
  text-shadow: 0px 2.3824px 55.3909px rgba(0, 0, 0, 0.42);
  text-transform: uppercase;
   //display: none;
}

.collaction_banner .banner_heading.heading-without-banner {
  position: static;
  text-shadow: none;
  color: #000;
  transform: none;
}
*/

/* New Collection Banner CSS */
.collection_banner_section {
  text-align: center;
  background: #ffffff;
  display: flex;
  max-width: 900px;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin: 0 auto;
  padding: 20px 20px 0;
  width: 100%;
}

.collection_banner_content {
  margin: 0 auto;
  color: #000;
  text-align: center;
  font-family: 'Adobe Caslon Pro', sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  align-self: stretch;
}

.collection_banner_heading {
  color: #000;
  font-family: 'Helvetica Neue', Arial, sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 100%;
  letter-spacing: 0.2px;
  text-transform: uppercase;
  margin: 0;
}

.isPercentShow {
  display: none;
}

.product_item:empty {
  display: none;
}

.color_swatches .swatches_inner {
  display: flex;
  gap: 7px;
}

.color_swatches .swatches_inner .nav-dots {
  position: relative;
}

li.nav-dots:after {
  position: absolute;
  top: -2px;
  width: 101%;
  height: 101%;
  border: 2px solid transparent;
  content: '';
  border-radius: 50%;
  left: -2px;
}

li.nav-dots.active:after,
.nav-dots[activeindex='true'] img {
  border: 2px solid rgba(0, 0, 0, 0.6) !important;
}

.color_swatches .nav-dots img {
  height: 20px;
  width: 20px;
  border-radius: 50%;
}

.color_swatches .swatches_inner .nav-dots:hover {
  cursor: pointer;
}

/* ETHICS IN FASHION CSS START */
.ethics_in_fashion {
  padding: 60px 0;
  border-top: 1px solid #000;
}

.ethics_content_inner .body_text,
.ethics_content_inner .sec_heading {
  text-align: center;
}

.ethics_content_inner .body_text {
  margin-bottom: 50px;
}

.fashion_img_grid {
  display: flex;
  align-items: center;
  gap: 30px;
  justify-content: center;
}

.fashion_img_grid img {
  width: 55px;
}

.apply_filter_cta_wrapper {
  display: none;
}

.body_text a {
  font-family: 'adobe-caslon-pro', sans-serif;
}

/* ETHICS IN FASHION CSS END */

/* common css */
/* * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
} */

body {
  margin: 0px !important;
}

.vue-logo-back {
  background-color: black;
}

img {
  max-width: 100%;
}

.pt-6 {
  padding-top: 1.5rem;
}

.flex {
  display: flex;
}

button {
  cursor: pointer;
  background-color: transparent;
  outline: none;
  border: none;
}

button:focus {
  outline: none;
}

ul {
  list-style: none;
  width: 100%;
  text-align: center;
  justify-content: center;
}

.card-title {
  font-size: 14px;
  text-align: left;
}

.card .card-title {
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  display: flex;
  align-items: center;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #000000;
  margin-top: 6px;
}

del {
  color: #b4b4b4;
}

.tmb_product_price {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* .tmb_discounted {
  margin-left: 10px;
} */

.discount-percentage {
  color: red;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  font-weight: 700;
}

.card-title.bold {
  font-weight: 700;
}

.filter-option {
  padding-top: 20px;
  padding-bottom: 20px;
  position: relative;
  z-index: 9;
}

.col {
  flex: 0 0 50%;
  max-width: 50%;
  padding-left: 1rem;
  padding-right: 1rem;
}

label {
  margin: 0;
}

.cross_heading {
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0.02em;
  color: #000000;
  padding-top: 59px;
  text-align: center;
}

.cross_heading_res {
  display: none;
}

/***** MultiSelect *****/

.dropdown {
  position: relative;
  cursor: pointer;
}

.multiselect {
  position: relative;
}

.sortFilter .multiselect .tmb_header_dopdown {
  right: 0;
  left: auto;
}

.multiselect .tmb_header_dopdown {
  background-color: #fff;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-top: 0;
  border-radius: 0 0 3px 3px;
  left: 0px;
  padding: 20px;
  position: absolute;
  top: 30px;
  width: 100%;
  list-style: none;
  min-width: 260px;
  margin: 0;
  opacity: 0;
  visibility: hidden;
  transition: 0.3s;
}

.multiselect ul {
  overflow-y: scroll;
  max-height: 250px;
  padding: 10px 0;
  overscroll-behavior: none;
}

.multiselect.active .tmb_header_dopdown {
  top: 0px;
  opacity: 1;
  visibility: visible;
}

.multiselect.active .btn_wrapper {
  opacity: 1;
  visibility: visible;
  padding-top: 10px;
}

.multiselect .btn_wrapper {
  opacity: 0;
  visibility: hidden;
}

.multiselect ul::-webkit-scrollbar {
  width: 5px;
}

/* Track */
.multiselect ul::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgb(223, 223, 223);
  border-radius: 10px;
}

/* Handle */
.multiselect ul::-webkit-scrollbar-thumb {
  background: rgb(155, 152, 152);
  border-radius: 10px;
}

/* .multiselect ul::-webkit-scrollbar {
    display: none;
} */

.sort_by_inner .multiselect ul {
  left: -204px;
}

.overselect {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
}

.c-form-input {
  background: transparent;
  border: none;
  outline: none;
  color: #000000;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0.02em;
  padding-right: 12px;
}

select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  text-indent: 1px;
  text-overflow: '';
}

.multiselect > .tmb_header_dopdown > ul > li {
  display: flex;
  align-items: center;
  gap: 5px;
}

.multiselect > .tmb_header_dopdown > ul > li:not(:last-child) {
  margin-bottom: 19px;
}

.multiselectOption {
  width: 14px;
  height: 14px;
  display: none;
}

.optionLabel {
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0.02em;
  color: #000000;
  position: relative;
  padding-left: 22px;
  cursor: pointer;
  text-align: start;
  text-transform: capitalize;
  /* cursor: pointer; */
}

.optionLabel::after {
  position: absolute;
  content: '';
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  width: 14px;
  height: 14px;
  background: #fff;
  border: 1px solid #000;
}

.multiselectOption:checked + label::after {
  background: #000;
}

.btn_wrapper {
  display: flex;
  align-items: center;
  gap: 1px;
  width: 100%;
}

.filterBtn {
  background: #ffffff;
  border: 1px solid #000000;
  padding: 4px 15px;
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  width: 100%;
  cursor: pointer;
  transition: 0.3s;
}

.multiselect .filterBtn:hover {
  background: #000;
  border: 1px solid transparent;
  color: #fff;
}

.filterBtn.modifier {
  background: #000;
  color: #fff;
}

.clearFilter {
  background: #000000;
  padding: 6px;
  max-width: 94px;
  width: 100%;
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: 0.02em;
  justify-content: center;
  color: #ffffff;
  gap: 4px;
  cursor: pointer;
  visibility: hidden;
}

.clearFilter.activeClear {
  visibility: visible;

  border: none;

  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0.02em;
  line-height: 14px;
  outline: none;
  padding-right: 12px;
}

.filter_row {
  padding: 0 15px;
  margin: 18px 0 12px;
  position: sticky;
  top: 0;
  z-index: 4;
}

.filters_inner,
.row_inner {
  display: flex;
  align-items: center;
  gap: 45px;
}

.row_inner {
  gap: 15px;
  justify-content: space-between;
  align-items: center;
  background: #ffff;
  padding: 10px 0;
}

.sortBtn {
  background: transparent;
  padding: 0;
  color: #000;
  border: none;
  outline: none;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  display: flex;
  gap: 5px;
  align-items: center;
  letter-spacing: 0.02em;
}

.product_grid {
  padding: 0 15px 103px;
  position: relative;
}

.load-more-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 0;
  margin: 0 15px;
}

.load-more-btn {
  background: #000000;
  color: #ffffff;
  border: none;
  padding: 14px 40px;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.02em;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  min-width: 200px;
}

.load-more-btn:hover:not(:disabled) {
  background: #333333;
}

.load-more-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.grid_inner {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  column-gap: 6px;
  row-gap: 28px;
}

/* .grid_inner[data-v-251cec58] {
  display: flex;
    column-gap: 0;
    row-gap: 28px;
    align-items: flex-start;
    flex-wrap: wrap;
    overflow: hidden;
} */
/* .grid_inner.product-containers > div {
    width: 25%;
} */

.grid_inner_max {
  grid-template-columns: repeat(6, 1fr) !important;
  transition: 0.3s;
}

.grid_inner_min {
  grid-template-columns: repeat(2, 1fr) !important;
  transition: 0.3s;
}

.grid_inner .card {
  border: none;
  position: relative;
}

.grid_inner .card .item_left {
  position: absolute;
  top: 7px;
  right: 7px;
  z-index: 1;
}

.card > img {
  width: 100%;
  height: 100%;
}

.responsiveFilter {
  display: none;
}

.sort_by_inner {
  display: flex;
  align-items: center;
  gap: clamp(20px, 11vw, 150px);
}

.progress {
  background: #252525;
  border-radius: 8px;
  height: 1px;
  width: 134px;
  outline: none;
  transition: background 450ms ease-in;
  appearance: none;
  -webkit-appearance: none;
}

.progress::-webkit-slider-thumb {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  -webkit-appearance: none;
  appearance: none;
  cursor: ew-resize;
  background: #252525;
}

.add_remove {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.add_remove button {
  position: relative;
  z-index: 1;
  height: 20px;
  width: 20px;
  top: 6px;
}

/* .nav-dots span {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  overflow-x: scroll;
  box-shadow: 0 0 1px 0 #000;
  border-radius: 50%;
} */

/* .nav-dots img {
  border: 1px solid #ccc;
} */

.nav-dots span::-webkit-scrollbar {
  display: none;
}

.pt-6 li {
  padding: 10px;
}

.p-2 {
  text-decoration: none;
}

.pageactive .p-2 {
  border-bottom: solid 3px #25a26b;
}

.productnotfound {
  display: block;
  padding: 10%;
  text-align: center;
}

.productfound {
  display: none;
}

.centeralign.addmargin .body_text {
  padding: 20px 0;
}

.quickAdd {
  border: 1px solid #000;
  padding: 8px 30px;
  background: #ffffff;
  gap: 15px;
  flex-direction: row;
  align-items: flex-start;
  transition: 0.3s;
  display: none;
}

.quickButton .quickAdd:hover {
  background: #000;
}

.quickButton .quickAdd:hover span {
  color: #fff;
}

/* .quickAdd_deactive {
  visibility: hidden;
} */

.quickAdd_active {
  visibility: visible;
}

.quickAdd span {
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  display: flex;
  align-items: center;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

.quickButton {
  justify-content: space-between;
  display: flex;
  opacity: 0;
  visibility: hidden;
  align-items: center;
  transition: 0.3s;
}

.product_img_wrapper .hoverImg {
  position: absolute;
  left: 0;
  visibility: hidden;
  opacity: 0;
  top: 0;
}

.product_item:hover .quickActive,
.product_img_wrapper:hover .hoverImg {
  opacity: 1;
  visibility: visible;
}

.quickButton .swatches_inner {
  text-align: left;
  /* width: 50%; */
}

.quickButton .product_cta_wrapper {
  width: 50%;
  text-align: end;
  display: none;
}

.nav-dots {
  /* width: 100%; */
  /* bottom: 9px; */
  /* height: 11px; */
  display: block;
  /* padding: 15px 0px; */
}

.nav-dots .nav-dot {
  top: 0px;
  min-width: 13px;
  height: 13px;
  margin: 0 6px;
  position: relative;
  border-radius: 100%;
  display: inline-block;
  background: red;
  border: 1px solid #e0e0e0;
  cursor: pointer;
  transition: 0.3s;
}

/* .nav-dots .nav-dot:hover {
  background-color: rgba(0, 0, 0, 0.8);
} */

input#img-1:checked ~ .nav-dots label#img-dot-1,
input#img-2:checked ~ .nav-dots label#img-dot-2,
input#img-3:checked ~ .nav-dots label#img-dot-3,
input#img-4:checked ~ .nav-dots label#img-dot-4,
input#img-5:checked ~ .nav-dots label#img-dot-5,
input#img-6:checked ~ .nav-dots label#img-dot-6 {
  background: rgba(0, 0, 0, 0.8);
}

.red {
  background: red;
}

.black {
  background: black;
}

.AZURE {
  background: #007fff;
}

.product-form__color-swatch {
  width: 50px;
  height: 50px;
  border-radius: 100%;
  margin: 4px;
}

.load-more-container {
  display: none;
}

.item_left {
  text-align: end;
  height: 12px;

  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 12px;
  align-items: center;
  letter-spacing: 0.02em;

  color: #878787;
  visibility: hidden;
  transition: all 200ms ease-in-out;
}

.out_of_stock img {
  opacity: 0.2;
}

.product_item:hover .item_left_active {
  visibility: visible !important;
}

.product_img_wrapper {
  position: relative;
  aspect-ratio: 1/1;
  overflow: hidden;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.5s infinite;
}

@keyframes skeleton-shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.out_of_stock_text {
  position: absolute;
  top: 50%;
  left: 50%;
  font-weight: 700;
  font-size: 24px;
  line-height: 12px;
  align-items: center;
  letter-spacing: 0.02em;
  color: red;
  transform: translate(-50%, -50%);
  visibility: hidden;
}

.out_of_stock_text_active {
  visibility: visible !important;
}

.color_swatches {
  position: relative;
  max-width: 142px;
  width: 100%;
  overflow: hidden;
  padding: 0 20px;

  /* padding-left:0; */
  transition: 0.3s;
  z-index: 1;
}

.color_swatches.tmbSlider {
  margin-left: -15px;
  margin-top: 5px;
}

.color_swatches.tmbSlider.removeMargin {
  margin-left: 0;
}

.color_swatches.add-padding {
  padding-left: 15px;
}

.arrow_icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: -11px;
  line-height: 0;
  cursor: pointer;
}

/* RSPONSIVE FILTER BTNS CSS START */
.filter_responsive {
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 3;
  display: none;
}

.filter_responsive .filter_cta_wrapper {
  display: flex;
  align-items: center;
  gap: 2px;
}

.filter_cta {
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  letter-spacing: 0.02em;
  color: #000000;
  background: #e9e7e3;
  border: 1px solid #000000;
  width: 100%;
  padding: 14px;
}

.filters_responsive {
  display: none;
}

/* RSPONSIVE FILTER BTNS CSS END*/
.activecolor {
  border: 1px solid #878787 !important;
}

.product_img_wrapper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
}

@media (min-width: 768px) {
  .filter .overselect svg,
  .sortFilter svg {
    transition: 0.3s;
  }

  .filter:hover .overselect svg,
  .sortFilter:hover svg {
    transform: rotate(180deg);
  }
}

/* RESPONSIVE BREAKPOINTS START */
@media (max-width: 1440px) {
  .grid_inner_max .product_img_wrapper img {
    height: 100%;
  }
}

@media (max-width: 1410px) {
  .grid_inner_max {
    grid-template-columns: repeat(4, 1fr) !important;
  }

  .grid_inner {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 1200px) {
  /* .product_img_wrapper img {
    height: auto;
    max-width: 348px;
  } */

  .quickAdd {
    padding: 8px 20px;
  }
}

@media (max-width: 1024px) {
  .out_of_stock_text {
    font-size: 14px;
  }

  .grid_inner {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 991px) {
  .progress {
    width: 105px;
  }

  .collaction_banner .banner_heading {
    font-size: 40px;
  }

  .grid_inner_max {
    grid-template-columns: repeat(3, 1fr) !important;
  }

  .grid_inner {
    grid-template-columns: repeat(2, 1fr);
  }

  .grid_inner_min {
    grid-template-columns: repeat(1, 1fr) !important;
  }
}

@media (max-width: 767px) {
  /* Original banner responsive CSS (commented out) */
  /*
  .collaction_banner .banner_heading.heading-without-banner {
    padding: 20px 0 0;
  }
  */

  /* New banner responsive CSS */
  .collection_banner_section {
    padding: 40px 15px 30px;
    margin: 0 auto;
  }

  .collection_banner_heading {
    font-size: 15px;
    margin-bottom: 15px;
  }

  .tmb_product_price.collection-product-card-price-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0;
  }
  .collection-product-card-price-container span {
    display: block;
    white-space: nowrap;
  }

  .discount-percentage {
    display: block;
    margin-top: 5px;
  }

  .tmb_discounted {
    margin-left: 10px;
  }

  .product_img_wrapper img {
    height: 100%;
    max-width: 100%;
    width: 100%;
  }

  .quickButton {
    opacity: 1;
    visibility: visible;
  }

  .filter_row {
    margin: 18px 0 0px;
    z-index: 5;
  }

  .product_cta_wrapper {
    display: none;
  }

  .grid_inner {
    grid-template-columns: repeat(2, 1fr) !important;
    column-gap: 2px;
    row-gap: 11px;
  }

  .card-title {
    font-size: 12px;
    margin: 10px 0 0;
  }

  .product_grid,
  .filter_row {
    padding: 0 2px;
  }

  .product_grid {
    padding-bottom: 80px;
  }

  .filter {
    width: 100%;
  }

  .dropdown {
    display: flex;
    align-items: center;
    width: 100%;

    background: #e9e7e3;
  }

  .overselect svg {
    position: absolute;
    top: 50%;
    right: 0;
    transition: 0.3s;
    transform: translateY(-50%);
  }

  .dropdown.active .overselect svg {
    transform: translateY(-50%) rotate(180deg);
  }

  .filters_responsive {
    display: block;
    z-index: 4;
  }

  .filters,
  .sort_by {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background: #e9e7e3;
    padding: 11px;
    height: calc(100% - 58px);
    z-index: 9;
    transition: 0.3s;
    overflow-y: scroll;
  }

  /* .filter.filter-modifier .multiselect.active{

  height: 141px;
} */
  /* .filter.size-filter .multiselect.active{
 height: 100px;
} */

  /* .qwe{
        height: 380px;
    } */
  .sort_by {
    height: 100%;
    min-height: 100vh;
    transform: translateX(110%);
  }

  .filters {
    transform: translateX(-110%);
  }

  .filters.show,
  .sort_by.show {
    transform: translateX(0);
  }

  .filters_inner {
    flex-direction: column;
    gap: 0;
    margin-top: 45px;
  }

  .filter_responsive {
    display: inline-block;
    margin-top: 13px;
  }

  .cross_heading {
    padding: 41px 0 37px;
    margin-bottom: -18px;
  }

  .row_inner {
    flex-direction: column;
    overflow: hidden;
    position: relative;
    padding: 0;
  }

  .filters .filter_cta_wrapper {
    display: flex;
    gap: 2px;
    width: calc(100% + 18px);
    margin-left: -9px;
  }

  /* .filters .filter_cta_wrapper .filter-modifier {
    border: none;
  } */

  .filters .multiselect ul {
    padding: 10px 0 20px;
  }

  .filters .filter_cta_wrapper .clear-modifier {
    background-color: #000000;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    /* opacity: 0;
    visibility: hidden; */
    transition: 0.3s;
  }

  .filters .filter_cta_wrapper .clear-modifier.activeClear {
    opacity: 1;
    visibility: visible;
  }

  .filters .filter_cta_wrapper .clear-modifier svg {
    width: 10px;
    height: 10px;
    margin-top: -2px;
  }

  .c-form-input {
    font-size: 18px;
    line-height: 21px;
    padding-right: 0;
  }

  .multiselect .tmb_header_dopdown {
    position: static !important;
    height: 0;
    overflow: hidden;
    background: #e9e7e3;
    box-shadow: none;
    display: inline-block;
  }

  .tmb_header_dopdown .btn_wrapper {
    display: none;
  }

  .optionLabel {
    font-size: 18px;
    line-height: 21px;
    padding-left: 35px;
  }

  .filter .optionLabel {
    padding-left: 30px;
  }

  .filter .multiselect .tmb_header_dopdown {
    padding: 10px 14px 0;
  }

  .filter .multiselect.active .tmb_header_dopdown {
    max-height: 250px;
    overflow: visible;
    height: 100%;
  }

  .filters_inner .clearFilter {
    display: none;
  }

  .multiselect {
    height: 0;
    max-height: 0;
    overflow: hidden;
    transition: 0.3s;
  }

  .multiselect.active {
    max-height: 250px;
    height: 100%;
    overflow: visible;
  }

  .range,
  .sortBtn {
    display: none;
  }

  .sortFilter {
    width: 100%;
  }

  .sort_by .filter-modifier {
    /* border: none; */
    width: 50%;
  }

  .sort_by .filter_cta_wrapper {
    text-align: end;
  }

  .sort_by .multiselect,
  .sort_by .multiselect .tmb_header_dopdown {
    top: 0px;
    opacity: 1;
    visibility: visible;
    height: 250px;
    overflow: visible;
  }

  .sort_by .multiselect ul {
    overflow: unset;
    height: auto;
    max-height: unset;
  }

  .sort_by .tmb_header_dopdown {
    padding: 0;
  }

  .sort_by .multiselect li {
    margin: 0 !important;
    padding: 14px 0 14px 9px;
    border-bottom: 1px solid #000;
  }

  .color_swatches {
    margin-top: 9px;
  }

  .ethics_in_fashion {
    padding: 30px 0 60px;
  }

  .fashion_img_grid {
    gap: 20px;
  }

  .fashion_img_grid img {
    width: 38px;
  }

  .ethics_content_inner .body_text,
  .ethics_content_inner .sec_heading {
    text-align: start;
    padding: 0 12px;
  }

  .filters_inner .filter {
    border-bottom: 1px solid #000;
    padding: 13px 0 13px 9px;
    position: relative;
    overflow: hidden;
  }

  .filters_inner .filter:last-child {
    border-bottom: none;
  }

  .apply_filter_cta_wrapper {
    display: block;
    background: #e9e7e3;
    padding: 11px;
    position: fixed;
    left: 0;
    bottom: 0px;
    transform: translateX(-110%);
    z-index: 99;
    transition: 0.3s;
    width: 100%;
    text-align: center;
  }

  .apply_filter_cta_wrapper.show {
    left: 50%;
    transform: translateX(-50%);
  }

  .apply_filter_cta {
    background: #000000;
    border: 1px solid #000000;
    width: 100%;
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    color: #ffffff;
    padding: 13px;
    transition: 0.3s;
  }

  .multiselect ul {
    overscroll-behavior: unset;
  }

  .filters_inner_row {
    height: 80vh;
    margin-bottom: 45px;
  }

  .apply_filter_cta[disabled],
  .filter_cta[disabled] {
    opacity: 0;
    visibility: hidden;
  }

  .color-filter ul {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 10px;
  }

  .collaction_banner .banner_heading {
    font-size: 30px;
    text-shadow: 0px 0.794134px 18.4636px rgba(0, 0, 0, 0.42);
  }

  .sec_heading {
    line-height: 43px;
  }
}

@media (max-width: 575px) {
  .collaction_banner .banner_heading {
    font-size: 16.3333px;
    text-shadow: 0px 0.794134px 18.4636px rgba(0, 0, 0, 0.42);
  }

  .grid_inner .card .item_left {
    top: 5px;
    right: 5px;
  }

  .filter_row {
    margin: 5px 0 12px;
  }
}

@media (max-width: 480px) {
  .collaction_banner img {
    height: 190px;
  }
}

span.ezsd-dots-wrapper {
  display: none !important;
}

.color_swatches.not-slider {
  padding: 0;
  margin-top: 5px;
}

/* Footer Banner Section CSS */
.footer_banner_section {
  background: #ffffff;
  display: flex;
  gap: 12px;
  align-items: flex-start;
  flex-direction: column;
  max-width: 973px;
  margin: 0 auto;
}

.footer_banner_content {
  margin: 0 auto;
  width: 100%;
}

.footer_banner_heading {
  font-family: 'Helvetica Neue', sans-serif;
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  letter-spacing: 0.3px;
  color: #000000;
  margin: 0 0 24px 0;
  text-transform: uppercase;
  width: 100%;
}

.footer_banner_description {
  font-family: 'adobe-caslon-pro', serif !important;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #000000;
  margin: 0 0 20px 0;
  transition: all 0.3s ease;
}

.footer_banner_description :deep(*) {
  font-family: 'adobe-caslon-pro', serif !important;
  font-size: 16px;
  line-height: 24px;
}

.footer_banner_description :deep(p) {
  margin: 0 !important;
}

.footer_banner_description :deep(p + p) {
  margin-top: 12px !important;
}

.readMoreButton {
  background: none;
  border: 0;
  padding: 0;
  font-family: 'adobe-caslon-pro', serif;
  font-size: 16px;
  text-align: end;
  width: 100%;
  cursor: pointer;
}

.footer_banner_description.footer_banner_rich_content {
  margin-left: 20px;
}

/* Footer Banner Responsive */
@media (max-width: 768px) {
  .footer_banner_section {
    padding: 30px 15px;
    margin: 20px 0 0 0;
  }

  .footer_banner_heading {
    font-size: 14px;
    line-height: 17px;
    margin-bottom: 15px;
  }

  .footer_banner_description {
    font-size: 13px;
    line-height: 18px;
  }

  .footer_banner_description * {
    font-size: 13px;
    line-height: 18px;
  }

  .readMoreButton {
    font-size: 14px;
  }
}

/* FAQ Section Styles */
.faq-section {
  max-width: 973px;
  margin: 20px auto 80px;
}

.faq-heading {
  font-family: 'Helvetica Neue', Arial, sans-serif;
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  color: #000000;
  margin: 0 0 12px 0;
  text-align: left;
}

.faq-item {
  border-bottom: 1px solid #dadada;
  padding: 0;
}

.faq-question {
  background: none;
  border: none;
  width: 100%;
  text-align: left;
  padding: 16px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  font-family: 'Helvetica Neue', Arial, sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #000000;
  transition: all 0.3s ease;
}

.faq-question:hover {
  opacity: 0.7;
}

.faq-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  margin-right: 12px;
}

.faq-icon svg {
  transition: all 0.3s ease;
}

.faq-question-text {
  flex: 1;
  text-align: left;
}

.faq-answer {
  font-family: 'adobe-caslon-pro', serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #000000;
  padding: 0 24px 20px 36px;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive styles for FAQ */
@media (max-width: 992px) {
  .faq-section {
    margin: 0px auto 60px;
    padding: 0 15px;
  }

  .faq-heading {
    font-size: 15px;
    line-height: 18px;
    margin-bottom: 20px;
  }

  .faq-question {
    font-size: 12px;
    line-height: 18px;
    padding: 15px 24px 15px 0px;
  }

  .faq-answer {
    font-size: 14px;
    line-height: 20px;
    padding: 0 24px 15px 36px;
  }
}
</style>

<!-- loader -->
<style scoped>
#loader {
  display: none;
  position: absolute;
  left: 50%;
  gap: 5px;
  transform: translateX(-50%);
  bottom: 0;
  z-index: 1;
  width: 100%;
  height: 50px;
  justify-content: center;
}

#loader span {
  vertical-align: middle;
  border-radius: 100%;
  display: inline-block;
  width: 10px;
  height: 10px;
  margin: 3px 2px;
  -webkit-animation: loader1 0.8s linear infinite alternate;
  animation: loader1 0.8s linear infinite alternate;
}

#loader span:nth-child(1) {
  -webkit-animation-delay: -1s;
  animation-delay: -1s;
  background: #dbdbdb;
}

#loader span:nth-child(2) {
  -webkit-animation-delay: -0.8s;
  animation-delay: -0.8s;
  background: #dbdbdb;
}

#loader span:nth-child(3) {
  -webkit-animation-delay: -0.26666s;
  animation-delay: -0.26666s;
  background: #dbdbdb;
}

#loader span:nth-child(4) {
  -webkit-animation-delay: -0.8s;
  animation-delay: -0.8s;
  background: #dbdbdb;
}

#loader span:nth-child(5) {
  -webkit-animation-delay: -1s;
  animation-delay: -1s;
  background: #dbdbdb;
}

@keyframes loader1 {
  from {
    transform: scale(0, 0);
  }

  to {
    transform: scale(1, 1);
  }
}

@-webkit-keyframes loader1 {
  from {
    -webkit-transform: scale(0, 0);
  }

  to {
    -webkit-transform: scale(1, 1);
  }
}

/* Load More Button Styles */
.load-more-container {
  text-align: center;
  padding: 30px 0;
  margin: 20px 0;
}

.load-more-btn {
  background-color: #000;
  color: #fff;
  border: none;
  padding: 12px 30px;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 0;
}

.load-more-btn:hover:not(:disabled) {
  background-color: #333;
  transform: translateY(-2px);
}

.load-more-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
  transform: none;
}

/* @-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
} */

/* Add animation to "page content" */
.animate-bottom {
  position: relative;
  -webkit-animation-name: animatebottom;
  -webkit-animation-duration: 1s;
  animation-name: animatebottom;
  animation-duration: 1s;
}

@-webkit-keyframes animatebottom {
  from {
    bottom: -100px;
    opacity: 0;
  }

  to {
    bottom: 0px;
    opacity: 1;
  }
}

@keyframes animatebottom {
  from {
    bottom: -100px;
    opacity: 0;
  }

  to {
    bottom: 0;
    opacity: 1;
  }
}
</style>
